"use strict";

class Colour
{
	/** @private */
	static _STATES =
		{ INITIALIZED: 0
		, ERROR:
			{ NOT_INITIALIZED: -2
			, NO_ID:           -4
			, NO_LABEL:        -8
		}
		, READY: { ADDED: 2	}
	}

	/** @private */
	constructor( id , label = "" , r = 1.0 , g = 1.0 , b = 1.0 , a = 1.0 )
	{
		/** @private @type {string} */
		this._label = ""
		/** @private @type {string} */
		this._id = ""

		/** @private @type {number} */
		this._opacity_float = 1.0
		/** @private @type {number} */
		this._blue_float 	= 1.0
		/** @private @type {number} */
		this._red_float 	= 1.0
		/** @private @type {number} */
		this._green_float 	= 1.0

		/** @private @type {number} */
		this._state = Colour._STATES.ERROR.NOT_INITIALIZED;

		if( typeof(id) != "string"  ||  id.length < 1 )
		{
			// id = "colour_" + hex_string + "#hex"
			this._state = Colour._STATES.ERROR.NO_ID
		}
		if( typeof(label) != "string"  ||  label.length < 1 )
		{
			// label = "Colour #" +  hex_string
			this._state = Colour._STATES.ERROR.NO_LABEL
		}

		this._id = String(id)
		this._label = String(label)

		this._red_float     = Number( r )
		this._green_float   = Number( g )
		this._blue_float    = Number( b )
		this._opacity_float = Number( a )

		if( this._label.length < 1 )
		{
			this._label = "#" + this.to_hex( 2 )
		}

		if( this._state === -2 )
		{
			this._state = Colour._STATES.INITIALIZED;
		}
	}

	/**
	 * @private
	 * @type { ?Colour }
	 */
	static _default_Colour = null
	static get Default_Colour()
	{
		if( this._default_Colour instanceof Colour )
		{
			return this._default_Colour;
		}
		else
		{
			const c = new Colour( "colour_default_colour" )
			c._state = 0
			return this._default_Colour = c;
		}
	}

	/** @private */	static _Colours_by_id    = new Map()
	/** @private */	static _Colours_by_label = new Map()
	/** @private */	static _Colours_by_hex   = new Map()
	/** @private @returns {boolean} */
	_add_this_colour_to_colours()
	{
		if( this.id    === null ) { return false; }
		if( this.label === null ) { return false; }

		const id_map    = Colour._Colours_by_id
		const label_map = Colour._Colours_by_label
		const hex_map   = Colour._Colours_by_hex

		const hex4  = this.to_hex(  4 )
		const hex8  = this.to_hex(  8 )
		const hex12 = this.to_hex( 12 )
		const hex16 = this.to_hex( 16 )

		if( id_map.has( this.id )      ) { return false; }
		if( label_map.has( this.label )) { return false; }

		id_map.set(    this._id    , this )
		label_map.set( this._label , this )

		// if( hex_map.has( hex4  )) { return false; }
		// if( hex_map.has( hex8  )) { return false; }
		// if( hex_map.has( hex12 )) { return false; }
		// if( hex_map.has( hex16 )) { return false; }

		hex_map.set( hex4  , this )
		hex_map.set( hex8  , this )
		hex_map.set( hex12 , this )
		hex_map.set( hex16 , this )

		return true;
	}

	get is_ready() { return this._state > Colour._STATES.INITIALIZED; }

	get id()
	{
		if( ("_id" in this)
			&& (typeof(this._id)==="string") && (this._id.length > 0) )
		{
			return this._id;
		}
		else return null;
	}

	get label()
	{
		if( ("_label" in this)
			&& (typeof(this._label)==="string") && (this._label.length > 0) )
		{
			return this._label;
		}
		else return null;
	}

	get red() { return this._red_float }

	get green() { return this._green_float }

	get blue() { return this._blue_float }

	get opacity() { return this._opacity_float }
	get alpha()   { return this._opacity_float }
	get transparency() { return 1.0 - this._opacity_float }

	get_red_float()   { return this._red_float }
	get_green_float() { return this._green_float }
	get_blue_float()  { return this._blue_float }

	get_opacity_float()      { return this._opacity_float }
	get_alpha_float()        { return this._opacity_float }
	get_transparency_float() { return 1.0 - this._opacity_float }

	get_red_255()     { return Math.round( this._red_float * 255 ) }
	get_green_255()   { return Math.round( this._green_float * 255.0 ) }
	get_blue_255()    { return Math.round( this._blue_float * 255.0 ) }

	get_opacity_255()        { return Math.round( this._opacity_float * 255.0 ) }
	get_alpha_255()          { return Math.round( this._opacity_float * 255.0 ) }
	get_transparency_255()   { return Math.round( 255.0 - (this._opacity_float * 255.0) ) }


	/**
	 * @returns { string? }
	 * @param { number } length
	 */
	to_hex( length , alpha_transparecny_colour = undefined )
	{
		if( "number" === typeof(length) )
		{

			length = Math.trunc(length);

			var transparency = false;

			if( length % 4  === 0 )
			{
				var transparency = true;
				length = length / 4;
			}
			else
			{
				if( length % 3  === 0 )
				{
					length = length / 3;
				}
				else
				{
					return null;
				}
			}

			const bits = length * 4;

			var result = "#"
			result += tools.numbers.decimal_0_to_1_to_hex( this._red_float   , bits )
			result += tools.numbers.decimal_0_to_1_to_hex( this._blue_float  , bits )
			result += tools.numbers.decimal_0_to_1_to_hex( this._green_float , bits )

			if( true === transparency )
			{
				result += tools.numbers.decimal_0_to_1_to_hex( this._opacity_float , bits )
			}

			return result;
		}
		else
		{
			return null;
		}
	}


	/**
	 * @returns { Colour? }
	 * @param { string } hex_string
	 */
	static from_hex( hex_string , default_result = null , id = "" , label = "" )
	{
		hex_string = hex_string.trim().toLowerCase()
		if( hex_string.charAt(0) === '#' )
		{
			hex_string = hex_string.substring(1)
		}

		if( this._Colours_by_hex.has(hex_string) )
		{
			return this._Colours_by_hex.get(hex_string)
		}

		const values = this._values_from_hex( hex_string )
		if( values.length > 0 )
		{
			const colour = new Colour( id , label
				, values[0]	, values[1]	, values[2]	, values[3] )
			if( colour._state === Colour._STATES.INITIALIZED )
			{
				if( colour._add_this_colour_to_colours() === true )
				{
					colour._state = Colour._STATES.READY.ADDED
					return colour;
				}
			}
		}

		return default_result;
	}

	/**
	 * @private
	 * @returns { number[] }
	 * @param { string } hex
	 */
	static _values_from_hex( hex )
	{
		const default_result = []
		if( typeof(hex)!="string" )	{ return default_result; }
		if( hex.length < 3 ) { return default_result; }
		var length = hex.length
		var transparency = false;
		if( length % 4  === 0 )
		{
			transparency = true;
			length = length / 4;
		}
		else
		if( length % 3  === 0 )
		{
			length = length / 3;
		}
		else { return default_result; }

		const divider = (1 << ( length * 4 )) - 1
		const values = [ 1.0 , 1.0 , 1.0 , 1.0 ]

		for( var i = 0 ;  i < 3 ;  i++ )
		{
			const start = i * length
			const end   = start + length
			const value = Number.parseInt( hex.slice( start , end ) , 16 )
			if( Number.isNaN(value) )
			{
				return default_result;
			}
			values[i] = value / divider
		}
		if( transparency === true )
		{
			const value = Number.parseInt( hex.substring( length * 3 ) , 16 )
			if( Number.isNaN(value) )
			{
				return default_result;
			}
			values[3] = value / divider
		}

		return values;
	}

	/**
	 * @param {string} label
	 * @returns {Colour?}
	 * */
	static get_Colour_by_label( label )
	{
		if( typeof(label)==="string" )
		{
			label = label.trim();

			if( this._Colours_by_label.has(label) )
			{
				return this._Colours_by_label.get(label);
			}
		}

		return null;
	}

	/**
	 * @param {string} id
	 * @returns {Colour?}
	 * */
	static get_Colour_by_id( id )
	{
		if( typeof(id)==="string" )
		{
			if( this._Colours_by_id.has(id) )
			{
				return this._Colours_by_id.get(id);
			}
		}

		return null;
	}

	/** @returns {boolean} */
	static is_Colour( colour )
	{
		if( (colour instanceof Colour)
			&& (colour != null)
			&& (colour != this._default_Colour)	)
		{
			return true;
		}
		return false;
	}

	/**
	 * @param {string} c
	 * @returns {Colour?}
	 * */
	static get_Colour( c )
	{
		if( typeof(c)==="string" )
		{
			c = c.trim()
			if( this._Colours_by_label.has(c) )
			{
				return this._Colours_by_label.get(c)
			}
			if( this._Colours_by_id.has(c) )
			{
				return this._Colours_by_id.get(c)
			}
			if( this._Colours_by_hex.has(c) )
			{
				return this._Colours_by_hex.get(c)
			}
		}
		else
		if(c instanceof Colour)
		{
			if( Colour.is_Colour(c) )
			{
				return c;
			}
		}

		return null;
	}
}


class Save_Slot
{
	/** @private */
	static _guid = "afcss7461368daf1331723aujbvljwwi" // guids.save_slots
	/** @private */
	static _magic = "afc01"
	/** @private */
	static _slots = []

	order = 0
	date = ""
	name = ""
	boat = { name: "" , d:100 , l:100 , w:100 , f:1 }

	/** @private */
	_code = ""

	/** @private */
	constructor()
	{

	}

	/** @param {Boat} boat  */
	static get_current_code( boat )
	{
		var code = ""

		for( var i0Q = 0 ;  i0Q < Question.all_in_order.length ;  i0Q++ )
		{
			/** @type {Question} */
			const q = Question.all_in_order[i0Q]
			if( (q instanceof Question) == false ) { continue; }

			var number = 0;
			var selections = "";
			const possible = q.possible_answer_ids

			for( var i0pa_id = 0 ;  i0pa_id < possible.length ;  i0pa_id+=1 )
			{
				const pa_id = possible[i0pa_id]

				const answer = Answer.get(pa_id)
				if( (answer != null) && answer.has_selection )
				{
					const index1 = answer.selection.selected_index1
					if( (index1 >= 0)
						&& (index1 < 90) )
					{
						selections += (110 + index1).toString().substring(1);
					}
					else
					{
						selections += "00";
					}
				}

				if( q.type === Question.Types.radio )
				{
					if( q.has_given_answer(pa_id) )
					{
						number = i0pa_id + 1;
					}
				}
				else
				if( q.type === Question.Types.checkbox )
				{
					number <<= 1;
					if( q.has_given_answer(pa_id) )
					{
						number += 1;
					}
				}
			}

			if( q.type === Question.Types.radio )
			{
				code += number.toString()
			}
			else
			if( q.type === Question.Types.checkbox )
			{
				number += 1000;
				code += number.toString().substring(1)
			}
			code += selections;
		}

		code += ","
		code += positive_number_to_hex( boat.length_in_cm , 4 )
		code += positive_number_to_hex( boat.width_in_cm  , 4 )
		code += positive_number_to_hex( boat.depth_in_cm  , 4 )
		var boat_factor = Math.round( boat.factor * 8 )
		code += positive_number_to_hex( boat_factor  , 1 )

		code += Save_Slot._magic

		return code;

		/** @param {number} x */
		/** @param {number} length */
		function positive_number_to_hex( x , length )
		{
			if( (typeof(length)==="number")
				&& (length > 0 )
				&& (length <= 8 ) )
			{
				const max = (length === 8) ? 0x7fFfFfFf : ( (1 << (length * 4)) - 1 )

				if( (typeof(x)==="number") && (x >= 0) && (x <= max) )
				{
					x &= max
					const result = "00000000" + x.toString(16)
					return result.substring( result.length - length )
				}
				return "00000000".substring( 8 - length )
			}
			return "";
		}
	}

	/**
	 * @param {Boat}   boat
	 * @param {string} code
	 *  */
	static set_from_code( boat , code )
	{
		if( typeof(code) != "string" )
		{
			return -99999;
		}

		if( (boat instanceof Boat) == false )
		{
			return -99998;
		}

		var char = "";
		var char_position = 0;

		/** @type {Question[]} */
		const questions = []
		var question_index = 0
		for( var i0Q = 0 ;  i0Q < Question.all_in_order.length ;  i0Q++ )
		{
			/** @type {Question} */
			const q = Question.all_in_order[i0Q]
			if( (q instanceof Question) == false ) { continue; }
			if( q.possible_answer_ids.length < 1 ) { continue; }

			questions.push(q);
		}

		while( (question_index < questions.length)
			&& (char_position < code.length ))
		{
			const question = questions[question_index++]
			const possible = question.possible_answer_ids;
			/** @type {Answer[]} */
			const answers = []
			for( var i0pa = 0 ;  i0pa < possible.length ;  i0pa++ )
			{
				const answer = Answer.get( possible[i0pa] )
				if( answer instanceof Answer )
				{
					answers.push( answer );
				}
			}

			if( question.type === Question.Types.radio )
			{
				char = code.charAt(char_position++)
				const number = tools.characters.to_digit(char)

				if( number > 0 )
				{
					if( number <= possible.length )
					{
						question.give_answer(possible[(number - 1)])
					}
				}
			}

			if( question.type === Question.Types.checkbox )
			{
				char = code.charAt(char_position++)
				var digits = "" + char
				char = code.charAt(char_position++)
				digits += char
				char = code.charAt(char_position++)
				digits += char

				var number = tools.strings.digits_to_positivie_integer(digits)

				if( Number.isInteger(number) == false )
				{
					number = -1;
				}

				if( number >= 0 )
				{
					question.unanswer()

					const possible = question.possible_answer_ids;
					var i0answer = possible.length - 1;

					while( i0answer >= 0 )
					{
						const answer = Answer.get( possible[i0answer--] )

						if( answer instanceof Answer )
						{
							if( number & 1 == 1 )
							{
								question.give_answer(answer)
							}

							number >>= 1;
						}
					}
				}
			}

			for( const answer of answers )
			{
				if( answer.has_selection )
				{
					char = code.charAt(char_position++)
					const selection_string = char + code.charAt( char_position++ )
					const selection_number
						= tools.strings.digits_to_positivie_integer( selection_string )
					if( selection_number > 10 )
					{
						answer.selection.select_index1(selection_number - 10)
					}
				}
			}
		}

		char = code.charAt(char_position++)

		if( char != "," )
		{
			return 0 - char_position;
		}
		else
		{
			boat.length_in_cm = next_four_hex_chars_to_number()
			boat.width_in_cm  = next_four_hex_chars_to_number()
			boat.depth_in_cm  = next_four_hex_chars_to_number()
			boat.update_answer_measurements()
		}

		return char_position;

		function next_four_hex_chars_to_number()
		{
			char = code.charAt(char_position++)
			var number_string = char
			char = code.charAt(char_position++)
			number_string += char
			char = code.charAt(char_position++)
			number_string += char
			char = code.charAt(char_position++)
			number_string += char

			const result = parseInt(number_string , 16)

			if( Number.isInteger(result) )
			if( result >= 0 )
			{
				return result;
			}

			return -1;
		}
	}

	static write_to_local_stroage( code )
	{
		develope.message( "STORAGE saving code: " + code )
		localStorage.setItem( "save_slot_code" , code )
		develope.message( "STORAGE saving code: " + code + " ... saved ..." )
	}

	static load_from_local_stroage( )
	{
		develope.message( "STORAGE loading code" )
		var code = localStorage.getItem("save_slot_code")
		if( typeof(code) != "string" )
		{
			code = ""
		}
		develope.message( "STORAGE loaded code: " + code )
		return code;
	}

	static write_to_session_stroage( code )
	{
		develope.message( "SESSION saving code: " + code )
		sessionStorage.setItem( "save_slot_code" , code )
		develope.message( "SESSION saving code: " + code + " ... saved ..." )
	}

	static load_from_session_stroage( )
	{
		develope.message( "SESSION loading code" )
		var code = sessionStorage.getItem("save_slot_code")
		if( typeof(code) != "string" )
		{
			code = ""
		}
		develope.message( "SESSION loaded code: " + code )
		return code;
	}

	static put_code_to_URL(code)
	{
		if( (typeof(code)==="string")
			&& (code.length > 10) )
		{
			history.replaceState( null , "" , "?code=" + code )
		}
	}

	static get_code_from_URL()
	{
		return tools_url_parameter("code")
	}
}


class Configurator_AF
{
	/** @private @type { Recipe! } */
	_recipe;

	/** @private @type { Boat! } */
	_boat;

	/** @private @type { Recipe_Calculator! } */
	_calculator;

	/** @private @type { Product[] } */
	_products_in_order = [];
	/** @private @type { Map<string,Product> } */
	_products_by_id = new Map();

	/** @private @type { Product_Kind[] } */
	_product_kinds_in_order = [];
	/** @private @type { Map<string,Product_Kind> } */
	_product_kinds_by_id = new Map();

	/** @private @type { Product_Category[] } */
	_product_categories_in_order = [];
	/** @private @type { Map<string,Product_Category> } */
	_product_categories_by_id = new Map();

	/** @private @type { Question[] } */
	_questions_in_order = [];
	/** @private @type { Map<string,Question> } */
	_questions_by_id = new Map();

	/** @private @type { Answer[] } */
	_answers_in_order = [];
	/** @private @type { Map<string,Answer> } */
	_answers_by_id = new Map();

	/** @private @type { Rule[] } */
	_rules_in_order = [];
	/** @private @type { Map<string,Rule> } */
	_rules_by_id = new Map();

	/** @private @type { Instruction[] } */
	_instructions_in_order = [];
	/** @private @type { Map<string,Instruction> } */
	_instructions_by_id = new Map();

	/** @private @type { Step[] } */
	_steps_in_order = [];
	/** @private @type { Map<string,Step> } */
	_steps_by_id = new Map();

	/** @private @type { Map<string,Colour> } */
	_Colours_by_label = new Map();


	constructor()
	{
		this._recipe = new Recipe( this );
		this._boat = new Boat( this );
		this._recipe.boat = this._boat;
		this._calculator = new Recipe_Calculator( this , this._recipe );
	}


	/** @returns { Recipe! } */
	get_recipe()
	{
		return this._recipe;
	}

	/** @returns { Boat! } */
	get_boat()
	{
		return this._boat;
	}

	/** @returns { Recipe_Calculator! } */
	get_calculator()
	{
		return this._calculator;
	}

	/**
	 * @returns { number }
	 * */
	add_product( p )
	{
		if( p instanceof Product )
		{
			if( this._products_by_id.has( p.id ) )
			{
				return -4;
			}

			const added = tools_array_push_if_not_included( this._products_in_order , p )

			if( true === added )
			{
				this._products_by_id.set( p.id , p )

				return this._products_in_order.length;
			}
		}

		return -2;
	}

	/**
	 * @returns { number }
	 * */
	add_product_kind( pk )
	{
		if( pk instanceof Product_Kind )
		{
			if( this._product_kinds_by_id.has( pk.id ) )
			{
				return -4;
			}

			const added = tools_array_push_if_not_included(
				this._product_kinds_in_order ,
				pk )

			if( true === added )
			{
				this._product_kinds_by_id.set( pk.id , pk )

				return this._product_kinds_in_order.length;
			}
		}

		return -2;
	}

	/**
	 * @returns { number }
	 * */
	add_product_category( pc )
	{
		if( pc instanceof Product_Category )
		{
			if( this._product_categories_by_id.has( pc.id ) )
			{
				return -4;
			}

			const added = tools_array_push_if_not_included(
				this._product_categories_in_order ,
				pc )

			if( true === added )
			{
				this._product_categories_by_id.set( pc.id , pc )

				return this._product_categories_in_order.length;
			}
		}

		return -2;
	}

	/**
	 * @returns { number }
	 * */
	add_question( q )
	{
		if( q instanceof Question )
		{
			if( this._questions_by_id.has( q.id ) )
			{
				return -4;
			}

			const added = tools_array_push_if_not_included( this._questions_in_order , q )

			if( true === added )
			{
				this._questions_by_id.set( q.id , q )

				return this._questions_in_order.length;
			}
		}

		return -2;
	}

	/**
	 * @returns { number }
	 * */
	add_answer( a )
	{
		if( a instanceof Answer )
		{
			if( this._answers_by_id.has( a.id ) )
			{
				return -4;
			}

			const added = tools_array_push_if_not_included( this._answers_in_order , a )

			if( true === added )
			{
				this._answers_by_id.set( a.id , a )

				return this._answers_by_id.length;
			}
		}

		return -2;
	}

	/**
	 * @returns { number }
	 * */
	add_rule( r )
	{
		if( r instanceof Rule )
		{
			if( this._rules_by_id.has( r.id ) )
			{
				return -4;
			}

			const added = tools_array_push_if_not_included( this._rules_in_order , r )

			if( true === added )
			{
				this._rules_by_id.set( r.id , r )

				return this._rules_by_id.length;
			}
		}

		return -2;
	}

	/**
	 * @returns { number }
	 * */
	add_instruction( i)
	{
		if( i instanceof Instruction )
		{
			if( this._instructions_by_id.has( i.id ) )
			{
				return -4;
			}

			const added = tools_array_push_if_not_included( this._instructions_in_order , i )

			if( true === added )
			{
				this._instructions_by_id.set( i.id , i )

				return this._instructions_in_order.length;
			}
		}

		return -2;
	}

	/**
	 * @returns { number }
	 * */
	add_step( s )
	{
		if( s instanceof Step )
		{
			if( this._steps_by_id.has( s.id ) )
			{
				return -4;
			}

			const added = tools_array_push_if_not_included( this._steps_by_id , s )

			if( true === added )
			{
				this._steps_by_id.set( s.id , s )

				return this._steps_in_order.length;
			}
		}

		return -2;
	}

	/**
	 * @returns { number }
	 * */
	add_colour( c )
	{
		if( Colour.is_Colour( c ) )
		{
			const label = c.label;

			if( this._Colours_by_label.has( label ) )
			{
				return -4;
			}

			this._Colours_by_label.set( label , c )

			return this._Colours_by_label.size;
		}

		return -2;
	}


	get_amount_of_questions()
	{
		return this._questions_in_order.length;
	}


	/** @param { number } index1 */
	get_question( index1 )
	{
		if( Number.isInteger( index1 ) )
		{
			const i0 = index1 - 1;

			if( (index1 > 0) && (i0 < this._questions_in_order.length) )
			{
				return this._questions_in_order[i0];
			}
		}

		return null;
	}


	/** @returns { boolean } */
	are_all_questions_answered()
	{
		/** @type {Question[]} */
		const questions = Question.all_in_order

		if( questions.length < 1 )
		{
			return false;
		}

		for( const question of questions )
		{
			if( question instanceof Question )
			{
				if( (question.type === Question.Types.radio) )
				{
					if( question.has_given_answer() == false )
					{
						return false;
					}
				}
				else
				if( (question.type === Question.Types.measurements) )
				{
					if( this._boat.has_valid_measurements() == false )
					{
						return false;
					}
				}
			}
			else
			{
				return false;
			}
		}

		console.debug( "All " + questions.length + " questions answered" )

		return true;
	}


	/** @returns { Question? } */
	get_first_unanswered_question()
	{
		/** @type {Question[]} */
		const questions = Question.all_in_order

		for( const question of questions )
		{
			if( question instanceof Question )
			{
				if( (question.type === Question.Types.radio) )
				{
					if( question.has_given_answer() == false )
					{
						return question;
					}
				}
				else
				if( (question.type === Question.Types.measurements) )
				{
					if( this._boat.has_valid_measurements() == false )
					{
						return question;
					}
				}
			}
		}

		return null;
	}

}


class Base_Object
{
	error = -1;
	ready = false;
	order = 0.0;
	/** @private */
	_id_value = "";

	data = {};
	html = {};
	custom = null;
	strings = null;

	static id_prefix = "";
	static id_class = "";

	static all_in_order = []
	static all_by_id = {}

	// constructor( class_name , id , prefix , order = undefined )
	constructor( id , order = NaN )
	{
		this._id_class_setup();
		if( this.constructor.id_is_valid( id ) )
		{
			this._id_value = id
			this.order = this._add_this();
		}
		if( typeof(order) === "number" )
		{
			if( !isNaN( order)  && !isFinite( order) )
			{
				this.order = order;
			}
		}

		if( !this.data ) { this.data = {} }
		if( !this.html ) { this.html = {} }
	}

	get id() {return this._id_value}
	// set id( id_value )
	// {
	// 	this.constructor.id_set( this , id_value )
	// }

	/**@param {Base_Object} object */
	static id_set( object , id_value )
	{
		if( id_value in this.all_by_id ) { return false }

		const old_id = object._id_value
		object._id_value = id_value
		this.all_by_id[ id_value ] = object
		this.all_by_id[ old_id ] = null
		delete this.all_by_id[ old_id ]

		return true;
	}

	/** @returns {?this} */
	static get( x )
	{
		if( typeof(x) === "number" )
		{
			return this.get_by_order( x );
		}
		else
		if( typeof(x) === "string" )
		{
			return this.get_by_id( x )
		}
		else
		if( x instanceof this )
		{
			return x;
		}
		else return null;
	}

	/** @param {string} id */
	static get_by_id( id )
	{
		if( typeof(id) === "string" )
		{
			id = id.trim()
			// id = id.trim().toLowerCase()
			if( id in this.all_by_id )
			{
				return this.all_by_id[ id ]
			}
		}
		return null;
	}

	/** @private */
	_add_this()
	{
		const y = this.constructor
		y.all.push( this );
		y.all_by_id[this.id] = this;
		y.all_in_order.push( this );
		// Object_With_ID.all_objects.push( this );
		return y.all_in_order.length;
	}

	static sort_by_order()
	{
		if( this.all_in_order.length > 1 )
		{
			this.all_in_order.sort( compare_order )
		}

		function compare_order( a , b )
		{
			try
			{
				return a.order - b.order;
			}
			catch( e ) {	}
			return 0;
		}
	}

	/** @private */
	_id_class_setup()
	{
		const y = this.constructor

		if( Object.hasOwn( y , "id_class" ))
		{
			return true;
		}
		else
		{
			Object.defineProperty( y , "id_class"     , { value: y.name } )
			Object.defineProperty( y , "all"          , { value: []     } )
			Object.defineProperty( y , "all_by_id"    , { value: {}     } )
			Object.defineProperty( y , "all_in_order" , { value: []     } )
			Object.defineProperty( y , "all_in_creation_order" , { value: []     } )
			// y.id_class = y.name
			// y.all = []
			// y.all_by_id = {}
			// y.all_in_order = []
			if( !(Object.hasOwn( y , "id_prefix" )))
			{
				Object.defineProperty( y , "id_prefix"    , { value: ""     } )
			}
		}

		return true;
	}

	/** @param {number} order */
	static get_by_order( order )
	{
		if( typeof( order ) === "number" )
		{
			if( order < 1 ) return null;
			if( order > this.all_in_order.length ) return null;
			return this.all_in_order[(order - 1)];
		}
		return null;
	}

	static get_amount()
	{
		return this.all_in_order.length;
	}

	/** @param {string} id */
	id_set( id )
	{
		if( typeof(id) === "string" )
		{
			if( !id.startsWith(this.constructor.id_prefix) )
			{
				id = "" + this.constructor.id_prefix + id;
			}
			if( this.constructor.id_is_valid(id) )
			{
				this._id_value = id
				return true;
			}
		}
		else return false;
	}

	/**
		* @param {string} id
		*	@returns {boolean}
	*/
	static id_is_valid( id )
	{
		if( typeof(id) === "string" )
		{
			id = id.trim().toLowerCase();
			return( id.length > this.id_prefix.length );
		}
		return false;
	}

	/** @param {string} id*/
	static normalize_id( id )
	{
		return this._normalize_id(id)
	}

	/** @param {string} id*/
	static _normalize_id( id )
	{
		id = id.trim();
		//id = id.toLowerCase();
		return id;
	}

	static Errors = { no_error: 0 }
}



class Measurement extends Base_Object
{
	constructor( id )
	{
		super(id);

		this.value = 100.0;
		this.unit = "cm";
		this.units = [ "mm" , "cm" , "m" , "in" , "f" ];
		this.selected_unit = "m";
		this.converted_value = 1.0;
	}

	change_unit( new_unit )
	{
		if (typeof (new_unit) === "string")
		{
			if (this.units.indexOf(new_unit) >= 0)
			{
				this.selected_unit = new_unit;
				this.convert_value()
			}
		}

		return this;
	}

	change_value( new_value , new_value_unit = "" )
	{
		if(  (typeof(new_value_unit) != "string")
			|| (new_value_unit.length < 1) )
		{
			new_value_unit = this.selected_unit
		}

		if( typeof(new_value) === "string" )
		{
			new_value = 0.0 + tools_number_parse_localized( new_value )
		}

		if( Number.isNaN( new_value ) )
		{
			new_value = ""
		}

		if( typeof(new_value) === "number")
		{
			const v = tools_convert_value( new_value , new_value_unit , this.unit )
			if( typeof(v) === "number" )
			{
				this.value = v
				this.convert_value()
				return true;
			}
		}

		return false;
	}

	convert_value()
	{
		const v = tools_convert_value( this.value , this.unit , this.selected_unit )
		if( typeof(v) === "number" )
		{
			this.converted_value = v
		}
		return this.converted_value;
	}
}


class Boat
{
	constructor( afc )
	{
		/** @private  @type {Configurator_AF} */
		this._configurator;

		if( afc instanceof Configurator_AF )
		{
			this._configurator = afc;
		}
		else
		{
			this._configurator = null;
		}

		this.name = "U96"
		this.type = "Motorboot"

		this._length = new Measurement( "boat_length")
		this._width  = new Measurement( "boat_width" )
		this._depth  = new Measurement( "boat_depth" )

		this._length.unit = this._width.unit  = this._depth.unit  = "cm"

		this._length.change_value( 1000.0 , "cm" )
		this._width.change_value(   400.0 , "cm" )
		this._depth.change_value(   200.0 , "cm" )

		this.factor = 1.0

		this._calculated_area_in_square_cm = 0
		this._effective_area_in_square_cm = 0

		this.material = ""
		this.other_product_id = ""

		this.data =
		{
			answers:
			{
				/** @type {Answer} */
				width: null,
				/** @type {Answer} */
				length: null,
				/** @type {Answer} */
				depth: null
			}
		}

		this.html =
		{
			input:
			{
				name: null
				, length: null
				, width: null
				, depth: null
				, material: null
				, factor: null
			}
			, output:
			{
				name: null
				, length: null
				, width: null
				, depth: null
				, material: null
			}
		}
	}

	get effective_area_in_square_cm()
	{
		return this._effective_area_in_square_cm
	}

	// set effective_area_in_square_cm( cm )
	// {
	// 	this._effective_area_in_square_cm = cm
	// }

	get effective_area_in_square_m()
	{
		return this._effective_area_in_square_cm / 10000
	}

	get area_in_square_m()
	{
		return this._calculated_area_in_square_cm / 10000
	}

	get length_in_cm() { return this._length.value }
	get width_in_cm()  { return this._width.value  }
	get depth_in_cm()  { return this._depth.value  }

	set length_in_cm( value )
	{
		if( typeof(value)==="number"
			&& !isNaN(value)
			&& (value > 0)
			&& (value <= 10000) )
		{
			this._length.change_value( value , "cm" )
		}
	}

	set width_in_cm( value )
	{
		if( typeof(value)==="number"
			&& !isNaN(value)
			&& (value > 0)
			&& (value <= 10000) )
		{
			this._width.change_value( value , "cm" )
		}
	}

	set depth_in_cm( value )
	{
		if( typeof(value)==="number"
			&& !isNaN(value)
			&& (value > 0)
			&& (value <= 10000) )
		{
			this._depth.change_value( value , "cm" )
		}
	}

	has_valid_measurements()
	{
		const values =
			[ this.length_in_cm
			, this.width_in_cm
			, this.depth_in_cm
			, this.factor
			]

		for( const value of values )
		{
			if( typeof(value) !== "number"
				|| Number.isFinite(value) === false
				|| value <= 0 )
			{
				return false;
			}
		}

		return (
			this.length_in_cm <= 10000
			&& this.width_in_cm <= 10000
			&& this.depth_in_cm <= 10000
		)
	}

	invalidate_measurement( name )
	{
		switch ( name )
		{
			case "length":
				this._length.change_value( 0 , "cm" )
				break;
			case "width":
				this._width.change_value( 0 , "cm" )
				break;
			case "depth":
				this._depth.change_value( 0 , "cm" )
				break;
		}
	}

	calculate_area()
	{
		if( this.has_valid_measurements() == false )
		{
			this._calculated_area_in_square_cm = 0
			this._effective_area_in_square_cm = 0
			return 0;
		}

		const l = this.length_in_cm
		const w = this.width_in_cm
		const d = this.depth_in_cm
		const f = this.factor

		const a = l * (w + d)
		
		this._calculated_area_in_square_cm = a;

		const effective_area_in_square_m = Math.ceil( a * f / 10000 )

		this._effective_area_in_square_cm = effective_area_in_square_m * 10000;

		develope.message("boat: calculated: ", this )

		return this._effective_area_in_square_cm;
	}


	update_answer_measurements()
	{
		this.data.answers.length.measurement.change_value( this.length_in_cm , "cm" )
		this.data.answers.width .measurement.change_value( this.width_in_cm  , "cm" )
		this.data.answers.depth .measurement.change_value( this.depth_in_cm  , "cm" )
		// this.data.answers.length.measurement.convert_value()
		// this.data.answers.width .measurement.convert_value()
		// this.data.answers.depth .measurement.convert_value()
		const fa = Answer.get("q6a4")
		if( fa instanceof Answer )
		{
			if( fa.has_selection )
			{
				const value = fa.selection.get_value()
				develope.message( "update_answer_measurements factor: " +  value )
				if( "number" == typeof(value) )
				{
					this.factor = value;
				}
			}
		}
	}
}


class Answer extends Base_Object
{
	type = 0;

	question_id = "";
	/** @private */
	_question = null;

	/**
	 * @private
	 * @type { ?Answer_Selection }
	*/
	_selection = null

	/** @type { ?Measurement } */
	measurement = null

	/** @type { string[] } */
	rule_ids = [];

	constructor(id, question_id, options = null)
	{
		super(id);
		this.question_id = question_id;

		const question = Question.get( question_id );
		if( question )
		{
			this._question = question
			question._possible_answer_ids.push(this.id);
			if( question.type == Question.Types.radio ) { this.type = Answer.Types.radio; }
			if( question.type == Question.Types.checkbox ) { this.type = Answer.Types.checkbox; }
			if( question.type == Question.Types.measurements ) { this.type = Answer.Types.measurement_unit; }
		}
		else
		{
			develope.error("ANSWER: question not found");
		}

		this.icon_image_url = "https://cdn.shopify.com/s/files/1/0867/0340/7384/files/antifoulingdefaulticon.jpg?v=1730690480";

		this.measurement = new Measurement("m" + this.id);

		this.rule_ids = [];
	}

	/** @returns {Question} */
	get question()
	{
		if( this._question == null )
		{
			this._question = Question.get( this.question_id );
		}
		return this._question;
	}

	/** @returns {boolean} */
	get has_selection()
	{
		return (this._selection != null) &&  (this._selection.amount > 0)
	}

	/** @type { Answer_Selection } */
	get selection()
	{
		if( this._selection == null  ||  this._selection == Answer_Selection.Empty )
		{
			this._selection = new Answer_Selection( this )
		}
		return this._selection;
	}

	selection_add( value , label_id = "" )
	{
		if( this._selection == null )
		{
			this._selection = new Answer_Selection( this );
		}
		this._selection.add( value , label_id )

		return this.selection
	}

	/** @type {boolean} */
	get given()
	{
		return this.question.has_given_answer(this)
	}

	give()
	{
		return this.question.give_answer( this );
	}

	/** @returns number */
	get selection_amount()
	{
		if( this._selection != null )
		{
			return this._selection.amount;
		}
		return 0;
	}

	/** @returns {?Answer} */
	static get( x )
	{
		if( typeof(x) === "number" )
		{
			return this.get_by_order( x )
		}
		else
		if( typeof(x) === "string" )
		{
				return this.get_by_id( x )
		}
		else
		if( x instanceof Answer )
		{
			return x;
		}
		else return null;
	}

	static Types =
		{ radio: 11
		, checkbox: 21
		, selection: 31
		, measurement: 101
		, measurement_unit: 102
	}
}

class Answer_Selection
{
	input_value = ""
	input_type = 0
	offers_type = 0
	output_type = 0

	amount = 0
	selected_index1 = 0
	required = false
	options =
		{ values: []
		, order: []
		, label_ids: []
		, labels: []
		, rule_ids: []
		, rules: []
	}

	constructor( answer )
	{
		this.answer = answer
		if( answer != null )
		{
			this.answer_id = answer.id
		}
		else
		{
			this.answer_id = ""
		}
		this.output = Answer_Selection.Types.custom;
	}

	/** @returns {boolean} */
	select_index1( index1 )
	{
		if( index1 > 0  && index1 <= this.amount )
		{
			this.selected_index1 = index1
			return true;
		}
		return false
	}

	/** @returns {boolean} */
	select_value( value , from_index1 = 1 )
	{
		from_index1 -= 1
		const index = this.options.values.indexOf( value , from_index1 )
		if( index >= 0 )
		{
			this.selected_index1 = index + 1
			return true;
		}
		return false
	}

	add( value , label_id = "" )
	{
		this.options.values.push( value )
		this.options.order.push( 0 )
		this.options.label_ids.push( label_id )
		this.options.labels.push( null )
		this.options.rule_ids.push( [] )
		this.options.rules.push( [] )
		this.amount++;
	}

	add_rule( index1 = 0, rule )
	{
		if( index1 > 0  && index1 <= this.amount )
		{
			index1 -= 1
		}
		else
		if( index1 == 0 )
		{
			index1 = this.amount - 1;
		}
		else
		{
			index1 = -1;
		}

		if( index1 >= 0 )
		{
			this.options.rules[index1].push( rule )
			this.options.rule_ids[index1].push( rule.id )
		}
	}

	add_rule_id( index1 = 0 , rule_id )
	{
		if( index1 > 0  && index1 <= this.amount )
		{
			index1 -= 1
		}
		else
		if( index1 == 0 )
		{
			index1 = this.amount - 1;
		}
		else
		{
			index1 = -1;
		}

		if( index1 >= 0 )
		{
			this.options.rules[index1].push( null )
			this.options.rule_ids[index1].push( rule_id )
		}
	}

	set_label( label , index1 = 0 )
	{
		if( index1 > 0  && index1 <= this.amount )
		{
			index1 -= 1
		}
		else
		if( index1 == 0 )
		{
			index1 = this.amount - 1;
		}
		else
		{
			index1 = -1;
		}

		if( index1 >= 0 )
		{
			this.options.labels[index1] = label
		}
	}

	get_value( index1 = 0 , default_value = null )
	{
		if( index1 === 0 ) { index1 = this.selected_index1	}

		if( index1 > 0  && index1 <= this.amount )
		{
			return this.options.values[index1 - 1]
		}
		return default_value;
	}

	get_label( index1 = 0 )
	{
		if( index1 === 0 ) { index1 = this.selected_index1	}
		else
		if( index1 > 0  && index1 <= this.amount )
		{
			const label = this.options.labels[index1 - 1]
			{
				return label
			}
		}
		return null;
	}

	get_label_id( index1 )
	{
		if( index1 === 0 ) { index1 = this.selected_index1	}

		if( index1 > 0  && index1 <= this.amount )
		{
			return this.options.label_ids[index1]
		}
		return null;
	}

	get_rules_ids( index1 )
	{
		if( index1 === 0 ) { index1 = this.selected_index1	}

		if( index1 > 0  && index1 <= this.amount )
		{
			return this.options.rule_ids[index1]
		}
		return [];
	}

	get_rule_count( index1 )
	{
		if( index1 === 0 ) { index1 = this.selected_index1	}

		if( index1 > 0  && index1 <= this.amount )
		{
			return this.options.rule_ids[index1].length
		}
		return [];
	}

	get_rule( index1 , rule_index1 )
	{
		if( index1 === 0 ) { index1 = this.selected_index1	}

		if( index1 > 0  && index1 <= this.amount )
		{
			index1 -= 1;
			/** @type {Rule[]} */
			const rules = this.options.rules[index1]
			if( rule_index1 > 0  &&  rule_index1 <= rules.length )
			{
				rule_index1 -= 1;
				const rule = rules[rule_index1]
				if( rule == null )
				{
					const rule_id = this.options.rule_ids[index1][rule_index1]
					return Rule.get_by_id( rule_id )
				}
			}
			return null;
		}
		return null;
	}

	static Types =
		{	custom: 111
		,	product: 301
		,	product_kind: 302
		,	product_category: 303
	}

	static Empty = new Answer_Selection( null )
}


class Question extends Base_Object
{
	static id_prefix = "q";

	/**
	 * @private
	 * @type {string[]}
	 * */
	_possible_answer_ids = [];
	get possible_answer_ids()
	{
		return this._possible_answer_ids;
	}

	/**
	 * @private
	 * @type {string[]}
	 * */
	_given_answer_ids = [];

	/**
	 * @private
	 * @type {Answer[]}
	 * */
	_given_answers = [];

	constructor( id , type , options = null )
	{
		super( id );
		this.id_set(id);

		this.type = type;

		if( options )
		{
			if( options.order )
			{
				this.order = options.order;
			}
		}

		/** @type {Array<string>} */
		this._possible_answer_ids = [];

		/** @type {Array<string>} */
		this._given_answer_ids = [];
		/** @type {Array<Answer>} */
		this._given_answers = [];

		//  this.add_this();
	}

	/**
	 * @returns {boolean}
	 * @param {Answer? | string} answer
	 * */
	has_given_answer( answer = null )
	{
		if( answer === null )
		{
			return this._given_answer_ids.length > 0;
		}
		else
		if( typeof(answer) === "string" )
		{
			// a = a.trim().toLowerCase()
			answer = Question.normalize_id( answer )
			return (this._given_answer_ids.indexOf(answer) >= 0);
		}
		else
		if( answer instanceof Answer )
		{
			return (this._given_answer_ids.indexOf(answer.id) >= 0);
		}
		else return false;
	}


	unanswer()
	{
		this._given_answer_ids = []
		this._given_answers = []
	}


	/** @returns {number} */
	give_answer( answer , selection_index1 = 0 )
	{
		const a = Answer.get( answer )

		if( a != null
			&& this._possible_answer_ids.indexOf( a.id ) >= 0 )
		{
			if( this.type === Question.Types.radio )
			{
				if( this._given_answers.length == 1
					&& this._given_answers[0] === a )
				{
					return 1;
				}
				else
				{
					this._given_answers = [a]
					this._given_answer_ids = [ a.id ]
					return 2;
				}
			}
			else
			if( this.type === Question.Types.checkbox )
			{
				const removed_answers = 0 +
					+ tools_array_remove_element( this._given_answers , a )
					+ tools_array_remove_element( this._given_answer_ids, a.id )

				if( removed_answers === 0 )
				{
					this._given_answers.push( a )
					this._given_answer_ids.push( a.id )
					return 2;
				}
				else
				{
					return -2;
				}

			}
			else
			{ return 0; }
		}

		return 0;
	}


	/** @returns {Answer?} */
	get_given_answer( index1 = 1 )
	{
		const index0 = index1 - 1;

		if( index0 >= 0  &&  this._given_answer_ids.length > index0 )
		{
			return Answer.get( this._given_answer_ids[index0] );
		}
		else
		{
			return null;
		}
	}

	/** @returns {number} */
	answers_amount()
	{
		return this._given_answer_ids.length;
	}


	/** @returns {Answer[]} */
	get_given_answers()
	{
		if( this._given_answer_ids.length === this._given_answers.length )
		{
			return this._given_answers;
		}
		else
		{
			for( var iA = 0;  iA < this._given_answer_ids.length;  iA++ )
			{
				const answer_id = this._given_answer_ids[iA]
				const answer = Answer.get( answer_id )
				if( this._given_answers.indexOf( answer ) < 0 )
				{
					this._given_answers.push( answer )
				}
			}

			for( var iA = 0;  iA < this._given_answers.length;  iA++ )
			{
				const answer = this._given_answers[iA];
				if( this._given_answer_ids.indexOf( answer.id ) < 0 )
				{
					this._given_answer_ids.push( answer.id )
				}
			}

			return this._given_answers;
		}
	}


	/** @returns {?Question} */
	static get( q )
	{
		if( typeof(q) === "number" )
		{
			return this.get_by_order( q );
		}
		else
		if( typeof(q) === "string" )
		{
			return this.get_by_id( q )
		}
		else
		if( q instanceof Question )
		{
			return q;
		}
		else return null;
	}


	static get are_all_questions_answered()
	{
		for( var i = 0 ;  i < Question.all_in_order.length ;  i++  )
		{
			/** @type {Question} */
			const question = Question.all_in_order[ i ];

			if( (question.type === Question.Types.radio) )
			{
				if( question.has_given_answer() == false )
				{
					return false;
				}
			}
		}

		return true;
	}


	static Types =
		{ radio: 11
		, checkbox: 21
		, measurements: 31
		, start: 2
		}
}

class Rule extends Base_Object
{
	static id_prefix = "r_"

	static get General_Rule() { return -1; }
	static get All_Answers()  { return -1; }

	static Actions =
		{ Default: 0
		// , variable:
		// 	{ _first: 1000 , _last: 1999
		// 	, set: 1002
		// 	}
		// , condition:
		// 	{ _first: 2000 , _last: 2999
		// 	, set: 2002
		// 	, unset: 2002
		// 	}
		, exclude: 12
		, value: 21
		, percent: 22
		, instruction: 44
		, instruction_for_step: 55
		, rules: 66
		, amount_set: 77
		, amount_increase: 78

		, primer: 955
		, current_antifouling: 966
	}

	/**
	 *	@private
	 *	@type {Object.<string , Rule[]>}	*/
	static all_by_answer_id = {}

	/**	@type {Rule[]}	*/
	static general_rules = []
	/** @type {boolean} */
	is_a_general_rule = false;

	/** @type {string[]} */
	for_answer_ids = [];
	has_selection = false;
	selection_value = null;

	/** @type {string[]} */
	for_product_ids = [];

	action = Rule.Actions.Default;
	value = 0;
	/** @type {string[]} */
	instruction_ids = [];
	/** @type {string} */
	step_id = "";

	rule_ids = [];

	variable = ""


	constructor(
		id = "" ,
		answer_ids_or_general ,
		selection_value = null ,
		product_ids ,
		action = Rule.Actions.Default ,
		value = 0 ,
		instruction_ids = "" ,
		step_id = "" ,
		rule_ids = []
	) {
		super( id )

		if( answer_ids_or_general == Rule.General_Rule )
		{
			this.is_a_general_rule = true
			Rule.general_rules.push( this )
		}
		else
		{
			this.is_a_general_rule = false
			this.for_answer_ids = tools_to_string_array(answer_ids_or_general);
		}

		this.selection_value = selection_value;

		this.for_product_ids = tools_to_string_array(product_ids);

		this.value = value;
		this.instruction_ids = tools_to_string_array(instruction_ids);
		this.step_id = step_id;
		this.rule_ids = tools_to_string_array( rule_ids );

		if( tools_object_has_value( Rule.Actions , action) )
		{
			this.action = action;
		}
		else
		{
			if( Rule.Actions[action] )
			{
				this.action = Rule.Actions[action];
			}
			else
			{
				this.error = 1;
				develope.error("Rule: ", this.id, " no action");
			}
		}

		this.error = 0

//		debugger

		if( this.error === 0 )
		{
			for( var i = 0 ;  i < this.for_answer_ids.length ;  i += 1 )
			{
				const answer =  Answer.get(this.for_answer_ids[i]);
				if( answer != null )
				{
					answer.rule_ids.push(this.id);
					if( answer.id in Rule.all_by_answer_id )
					{
						tools_array_push_if_not_included(
							Rule.all_by_answer_id[answer.id]
							, this )
					}
					else
					{
						Rule.all_by_answer_id[answer.id] = [this];
					}
				}
				else
				{
					this.error = 2;
				}
			}

			// for( var i = 0 ;  i < this.product_ids.length ;  i+=1 )
			// {
			// 	const product = products_by_id[ this.product_ids[i] ]
			// 	if( product )
			// 	{
			// 		product.rule_ids.push(this.id)
			// 	}
			// 	else
			// 	{
			// 		this.error = 3
			// 	}
			// }
		}
	}


	/**
	 * @param {Product | string} product_or_id
	 * @returns {boolean}
	 */
	is_for_product( product_or_id )
	{
		if( typeof(product_or_id) === "string" )
		{
			return( this.for_product_ids.indexOf( product_or_id ) >= 0 );
		}
		else
		if( product_or_id instanceof Answer )
		{
			return( this.for_product_ids.indexOf( product_or_id.id ) >= 0 );
		}
		else
		return false;
	}


	/**
	 * @param {Answer | string} answer
	 * @returns {boolean}
	 */
	is_for_answer( answer )
	{
		if( typeof(answer) === "string" )
		{
			return( this.for_answer_ids.indexOf( answer ) >= 0 );
		}
		else
		if( answer instanceof Answer )
		{
			return( this.for_answer_ids.indexOf( answer.id ) >= 0 );
		}
		else
		return false;
	}


	/**
	 * @param {number} rule_index1
	 * @returns {string?}
	 */
	get_rule_id( rule_index1 )
	{
		if( this.action === Rule.Actions.rules )
		if( rule_index1 > 0 )
		{
			return tools_array_value( this.rule_ids , rule_index1 - 1 , null );
		}
		return null;
	}


	/**
	 * @param {number} rule_index1
	 * @returns {Rule?}
	 */
	get_rule( rule_index1 )
	{
		if( this.action === Rule.Actions.rules )
		if( rule_index1 > 0 )
		{
			/**@type {string} */
			const rule_id =  tools_array_value( this.rule_ids , rule_index1 - 1 , "" );
			return Rule.get( rule_id )
		}
		return null;
	}


	/** @returns {Rule[]} */
	/** @param {Answer|string} answer_or_id */
	static get_by_answer( answer_or_id )
	{
		if( answer_or_id instanceof Answer )
		{
			answer_or_id = answer_or_id.id
		}
		if( typeof( answer_or_id ) === "string"
			&& answer_or_id.length > 0
			&& answer_or_id in this.all_by_answer_id )
		{
			return this.all_by_answer_id[answer_or_id]
		}
		return [];
	}


	/** @returns {?Rule} */
	static get( r )
	{
		return super.get( r )
	}


}

class Step extends Base_Object
{
	label_id = "";

	text_intro_id = "";
	text_extro_id = "";

	active = false;

	/** @type {string[]} */
	instruction_ids = [];

	/** @type {Object.<string, Product>} */
	products_by_kind = {}

	constructor( id , label_id = "" , order = Number.NEGATIVE_INFINITY , text_id = "")
	{
		super( id )
		if( order > Number.NEGATIVE_INFINITY )
		{
			this.order = 0 + order;
		}

		this.reset();

		this.text_intro_id = text_id;

		this.html.container = null;
		this.html.label = null;
		this.html.text = null;
	}

	reset()
	{
		this.deactivate()
		this.instruction_ids = [];
	}

	activate()   { this.active = true;  }
	deactivate() { this.active = false; }

	/** @returns {Step} */
	empty_copy()
	{
		const copy = {}

		copy.id    = this.id
		copy.order = this.order
		copy.html  = this.html

		copy.label_id        = this.label_id
		copy.text_intro_id   = this.text_intro_id
		copy.text_extro_id   = this.text_extro_id
		copy.active          = false
		copy.instruction_ids = []

		/** @type {Object.<string, Array<Product>>} */
		copy.products_by_kind = {}

		copy.reset      = this.reset
		copy.activate   = this.activate
		copy.deactivate = this.deactivate

		return copy;
	}

	/** @returns {Step} */
	copy()
	{
		const copy = {}

		copy.id    = this.id
		copy.order = this.order
		copy.html  = this.html

		copy.label_id        = this.label_id
		copy.text_intro_id   = this.text_intro_id
		copy.text_extro_id   = this.text_extro_id
		copy.active          = this.active
		copy.instruction_ids = this.instruction_ids.slice

		/** @type {Object.<string, Array<Product>>} */
		copy.products_by_kind = {}
		Object.assign( copy.products_by_kind , this.products_by_kind )

		copy.reset      = this.reset
		copy.activate   = this.activate
		copy.deactivate = this.deactivate

		return copy;
	}

	/** @returns {Step} */
	static get(s)
	{
		return super.get(s)
	}

}

class Instruction extends Base_Object
{
	/** @type {string[]} */
	text_ids = [];
	paragraph = 3;
	static Paragraph =
		{ none      : 0
		, start     : 1
		, end       : 2
		, paragraph : 3
	}

	step_id = "";
	amount = 0;
	instruction_product_id = "";

	constructor( id , text_ids = "" , amount = 0 , step_id = "" , instruction_product_id = "" )
	{
		super( id )

		this.text_ids = tools_to_string_array( text_ids )

		this.step_id = "" + step_id;
		this.amount = 0 + amount;

		this.instruction_product_id = "" + instruction_product_id;
	}

	/** @returns {Instruction?} */
	static get( id_or_number_Instruction )
	{
		return super.get(id_or_number_Instruction);
	}
}

class Product extends Base_Object
{
	constructor( id , kind_id , label = "" )
	{
		super( id )

		this.kind_id = kind_id;
		const k = Product_Kind.get(kind_id)
		if( k != null )
		{
			k.product_ids.push(id);
		}
		this.category_ids = [];
		this.categories = [];
		this.label = label;

		/** @type {string[]} */
		this.texts = [];
		/** @type {string[]} */
		this.image_urls = [];
		/** @type {Colour[]} */
		this._Colours = [];

		/** @type {number[]} */
		this.amounts = [];
		/** @type {Map<Colour,number[]>} */
		this._amounts_by_Colour = new Map()
		/** @type {number[]} */
		this._amounts_without_Colour = []

		this.relative_price = 100;
		this.relative_value = 100;
		this.coverage_sqm_per_l = 10.0;

		/** @type {string} */
		this.rule_ids = []
		/** @type {Rule[]} */
		this.rules = []

		/** @private @type {Product_Variant[]} */
		this._variants = []
		/** @type {Map<Colour,Map<number,Product_Variant[]>>} */
		this._variants_by_Colour_by_amount_sorted_by_relative_value = new Map()
		/** @private @type {Product_Variant[]} */
		this._variants_without_Colour = []
		/** @type {Map<number,Product_Variant[]>} */
		this._variants_without_Colour_by_amount = new Map()
	}

	get_coverage_sqm_per_l( fallback = 10.0 )
	{
		if( typeof(this.coverage_sqm_per_l) === "number"
			&& Number.isFinite(this.coverage_sqm_per_l)
			&& this.coverage_sqm_per_l > 0 )
		{
			return this.coverage_sqm_per_l;
		}

		return fallback;
	}


	// get has_Colours()
	// {
	// 	if( Array.isArray(this._Colours) )
	// 	{
	// 		if( this._Colours.length === 0 )
	// 		{
	// 			return false;
	// 		}
	// 		else
	// 		{
	// 			return Colour.is_Colour(this._Colours[0]);
	// 		}
	// 	}
	// 	else { return false; }
	// }


	/**
	 * @returns {boolean}
	 * @param {Colour?} colour
	*/
	has_Colour( colour = Colour.Default_Colour )
	{
		if( Array.isArray(this._Colours) )
		{
			if( this._Colours.length === 0 )
			{
				return false;
			}

			if( colour === Colour.Default_Colour )
			{
				return Colour.is_Colour(this._Colours[0]);
			}

			if( Colour.is_Colour(colour) )
			{
				return (this._Colours.indexOf(colour) >= 0);
			}
		}

		return false;
	}


	/**
	 * @returns {Colour?}
	 * @param {number!} index1
	 */
	get_Colour( index1 )
	{
		if( typeof(index1) === "number" )
		{
			if( (index1 > 0) && (index1 <= this._Colours.length) )
			{
				const colour = this._Colours[index1 - 1]
				if( Colour.is_Colour(colour) )
				{
					return colour;
				}
				else
				{
					var index0 = index1
					var c = null
					while( index0 < this._Colours.length )
					{
						c = this._Colours[index0]
						if( Colour.is_Colour(c) )
						{
							this._Colours[index1 - 1] = c
							this._Colours[index0] = null
							break;
						}
						index0 += 1
					}
					if( index0 >= this._Colours.length )
					{
						this._Colours.length = index1
					}
					if( Colour.is_Colour(c) )
					{
						return c;
					}
				}
			}
		}

		return null;
	}

	/** @returns {Colour[]} */
	get_Colours()
	{
		return this._Colours;
	}


	/**
	 * @typedef {object} Shopify_Variant_Data
	 * @property {string | number} id
	 * @property {number} order
	 * @property {string[]} options
	 * @property {number} price
	 * @property {string} price_string
	 * @property {string} colour
	 * @property {number} amount_ml
	*/


	data = {
		shopify: {
			id: "",
			url: "",
			handle: "",
			/** @type {string[]} */
			usps: [],
			/** @type {Shopify_Variant_Data[]} */
			variants: []
		}
	};


	add_to_category( category , create_if_not_exist = false )
	{
		/** @type {Product_Category} */
		var c = Product_Category.get( category )

		if( c == null  &&  typeof(category) === "string"  &&  create_if_not_exist === true )
		{
			c = new Product_Category( category )
		}

		if( c != null )
		{
			c.add_product( this.id )
		}
	}


	get variant_count() { return this._variants.length; }

	add_variant( id , label , amount = -1 , colour = Colour.Default_Colour , price = -1 , price_string = "" , currency_symbol = "" )
	{
		if((colour instanceof Colour) == false)
		{
			colour = Colour.Default_Colour
		}

		const new_variant = new Product_Variant( this.id + "_" + id , id , this , label , amount , colour , price , price_string)

		if( typeof(currency_symbol) === "string"  &&  currency_symbol.length > 0 )
		{
			new_variant.price_unit_string = currency_symbol
		}

		colour = new_variant.Colour
		amount = new_variant.amount

		if( amount > 0 )
		{
			tools_array_push_if_not_included( this.amounts , amount )
		}

		if( Colour.is_Colour(colour) )
		{
			if( this._Colours.indexOf(colour) < 0 )
			{
				this._Colours.push(colour)
			}
			if( this._amounts_by_Colour.has(colour) == false )
			{
				this._amounts_by_Colour.set(colour, [])
			}
			if( amount > 0 )
			{
				tools_array_push_if_not_included(
					this._amounts_by_Colour.get(colour)
					,amount )
			}

			if( this._variants_by_Colour_by_amount_sorted_by_relative_value.has(colour) == false)
			{
				const amounts = new Map();
				const variants = this._variants_by_Colour_by_amount_sorted_by_relative_value
				variants.set(colour , amounts)
			}
			const amounts = this._variants_by_Colour_by_amount_sorted_by_relative_value.get(colour)
			if( amount > 0 )
			{
				if( amounts.has(amount) == false )
				{
					amounts.set(amount , [])
				}
				amounts.get(amount).push(new_variant)
			}
		}
		else
		{
			this._variants_without_Colour.push( new_variant );
			if( amount > 0 )
			{
				if( this._amounts_without_Colour.indexOf(amount) < 0 )
				{
					this._amounts_without_Colour.push(amount)
				}
				if( this._variants_without_Colour_by_amount.has(amount) == false )
				{
					this._variants_without_Colour_by_amount.set(amount , [])
				}
				this._variants_without_Colour_by_amount.get(amount).push(new_variant)
			}
		}

		this._variants.push( new_variant )

		this._sort_variants_by_relative_value_per_colour_per_amount()

		return new_variant;
	}

	/**
	 * @returns {?Product_Variant}
	 * @param {number} [index1]  */
	get_variant( index1 )
	{
		if( typeof(index1)!="number" ) { return null; }
		if( Number.isInteger(index1) == false ) { return null; }
		if( index1 < 1 ) { return null; }
		if( index1 > this._variants.length ) { return null; }

		const result = this._variants[index1 - 1]

		if( result instanceof Product_Variant )
		{
			return result;
		}
		else
		{
			return null;
		}
	}

	_sort_variants_by_relative_value_per_colour_per_amount()
	{
		// debugger

		for( const colour_key of this._variants_by_Colour_by_amount_sorted_by_relative_value.keys() )
		{
			const colour = this._variants_by_Colour_by_amount_sorted_by_relative_value.get( colour_key )

			for( const amount of colour.keys() )
			{
				const variants = colour.get( amount )

				variants.sort( Product_Variant.compare_by_relative_price )

				//variants.sort( compare_by_relative_price )
				/**
				 * @param {Product_Variant?} a
				 * @param {Product_Variant?} b   */
				// function compare_by_relative_price( a , b )
				// {
				// 	if((a instanceof Product_Variant)
				// 		&& (b instanceof Product_Variant))
				// 	{
				// 		if( a.has_relative_price()
				// 			&& b.has_relative_price() )
				// 		{

				// 		}
				// 	}
				// }
			}
		}

		for( const variants of this._variants_without_Colour_by_amount.values() )
		{
			variants.sort( Product_Variant.compare_by_relative_price )
		}

		this._variants_without_Colour.sort( Product_Variant.compare_by_relative_price )
	}

	/** @returns {Product?}  */
	static get(p)
	{
		return super.get(p)
	}
}

class Product_Variant extends Base_Object
{
	/** @private  @type {string} */
	_variant_id = "";
	get variant_id() { return this._variant_id; }

	/** @private  @type {string} */
	_label = "";
	get label() { return this._label; }

	/** @private  @type {string} */
	_product_id = "";
	get product_id() { return this._product_id }

	/** @private  @type {Product?} */
	_product_reference = null;
	get product()
	{
		if( this._product_reference instanceof Product )
		{
			return this._product_reference;
		}
		else
		{
			this._product_reference = Product.get( this._product_reference )
		}
		return this._product_reference;
	}

	/** @private  @type {number} */
	_amount = -1;
	get amount() { return this._amount;	}

	/** @private  @type {number} */
	_price = -1;
	get price() { return this._price;	}
	get price_value() { return this._price;	}
	
	/** @private  @type {string} */
	_price_unit_string = "";
	get price_unit_string() { return this._price_unit_string;	}
	set price_unit_string( s ) { this._price_unit_string = s;	}
	
	/** @private  @type {string} */
	_price_unit = "$US";
	get price_unit() { return this._price_unit;	}
	
	/** @private  @type {string} */
	_price_string = "-1.00$US";
	get price_string() { return this._price_string;	}

	/** @private  @type {number} */
	_relative_price = -1;
	get relative_price() { return this._relative_price; }
	get price_per_amount() { return this._relative_price; }

	/** @private  @type {Colour?} */
	_Colour = null;
	get Colour() { return this._Colour; }


	/**
	 * @param {Colour?} [colour=null]
	 * @param {Product | string} product_or_id  */
	constructor( id
		, variant_id , product_or_id
		, label = "" , amount = -1 , colour = null
		, price = -1 , price_string = "" )
	{
		super( id )
		this._variant_id = id

		if( typeof(variant_id)==="number" )
		{
			this._variant_id = String(variant_id)
		}
		if( typeof(variant_id)==="string" )
		{
			this._variant_id = variant_id
		}

		if( typeof(product_or_id)==="string" )
		{
			this._product_id = product_or_id
			product_or_id = Product.get(product_or_id)
		}
		if( product_or_id instanceof Product )
		{
			this._product_id = product_or_id.id
			this._product_reference = product_or_id
		}

		if( (typeof(label)==="string")
			&& (label.length > 0) )
		{
			this._label = label
		}

		if( (typeof(amount)==="number")
			&& (amount >= 0) )
		{
			this._amount = amount
		}

		if( colour instanceof Colour )
		{
			this._Colour = colour
		}

		if( (typeof(price)==="number")
			&& (price >= 0) )
		{
			this._price = price
			if( (typeof(price_string)==="string")
				&& (price_string.length > 0) )
			{
				this._price_string = price_string
			}
		}

		if( (this._amount > 0)
			&& (this._price > 0) )
		{
			this._relative_price = this._price / this._amount
		}
	}

	/** @returns {Product_Variant?}  */
	static get(p)
	{
		return super.get(p)
	}

	/**
	 * @returns {boolean}
	 * @param {Colour} colour
	 *  */
	has_colour( colour = null )
	{
		if( Colour.is_Colour(colour) )
		{
			return (this._Colour === colour);
		}
		return Colour.is_Colour(this._Colour);
	}

	/** @returns {boolean} */
	has_amount( amount = 0 )
	{
		if( amount > 0 )
		{
			return (amount === this._amount);
		}
		return (typeof(this._amount)==="number") && (this._amount > 0);
	}

	/** @returns {boolean} */
	has_price()
	{
		return (typeof(this._price)==="number") && (this._price > 0);
	}

	/** @returns {boolean} */
	has_relative_price()
	{
		return (typeof(this._relative_price)==="number") && (this._relative_price > 0);
	}

	/**
	 * @param {Product_Variant?} a
	 * @param {Product_Variant?} b
	 * @returns {number} */
	static compare_by_relative_price( a , b )
	{
		if((a instanceof Product_Variant)
			&& (b instanceof Product_Variant))
		{
			if( a.has_relative_price()
				&& b.has_relative_price() )
			{
				return a.relative_price - b.relative_price
			}
		}

		if( (a instanceof Product_Variant)
			&& a.has_relative_price() )
		{
			return -1;
		}

		if( (b instanceof Product_Variant)
			&& b.has_relative_price() )
		{
			return 1;
		}

		return 0;
	}
}

class Product_Kind extends Base_Object
{
	product_ids = [];
	recipe_index = -1

	constructor( id , recipe_index = -1 )
	{
		super( id )
	}

	/** @returns {?Product_Kind} */
	static get( k )
	{
		if( typeof(k) === "number" )
		{
			return this.get_by_order( k );
		}
		else
		if( typeof(k) === "string" )
		{
			return this.get_by_id( k )
		}
		else
		if( k instanceof Product_Kind )
		{
			return k;
		}
		else return null;
	}
}

class Product_Category extends Base_Object
{
	constructor( id, recipe_index = -1)
	{
		super( id )

		this.product_ids = [];
		this.recipe_index = recipe_index;

		/** @type {string[]} */
		this.include_categories_ids = []
		/** @type {Product_Category[]} */
		this.include_categories = []
	}

	/**
	* @param {object?} options
	* @param {boolean} options.create_if_not_exists
	*/
	include_category( categories , options = null )
	{
		var count_categories_added = 0;

		if( (Array.isArray(categories) == false) )
		{
			categories = [categories];
		}

		for( var i0 = 0;  i0 < categories.length;  i0++ )
		{
			var category = Product_Category.get(categories[i0]);
			if( (category == null) && (options) && (options.create_if_not_exists) )
			{
				if( typeof(categories[i0]) === "string" )
				{
					const category_id = categories[i0];
					category = new Product_Category( category_id );
				}
			}

			if( category != null )
			{
				if( this.include_categories_ids.indexOf( category.id ) < 0 )
				{
					this.include_categories_ids.push( category.id )
					this.include_categories.push( category )
				}
			}
		}

		return count_categories_added;
	}

	/** @param {string} product_id */
	add_product( product_id )
	{
		if( typeof product_id === "string" )
		{
			product_id = product_id.trim();
			if (product_id.length < 1) {
				return false;
			}
		}
		else
		{
			return false;
		}

		const product = Product.get( product_id );
		if( product != null )
		{
			tools_array_push_if_not_included(product.category_ids, this.id);
			if( this.product_ids.indexOf(product_id) < 0 )
			{
				this.product_ids.push(product_id);
				return false;
			}
		}
	}

	/** @returns {?Product_Category} */
	static get( c )
	{
		if( typeof(c) === "number" )
		{
			return this.get_by_order( c );
		}
		else
		if( typeof(c) === "string" )
		{
			return this.get_by_id( c )
		}
		else
		if( c instanceof Product_Category )
		{
			return c;
		}
		else return null;
	}
}

class Recipe
{
	/** @private  @type {Configurator_AF} */
	constructor( afc )
	{
		if( afc instanceof Configurator_AF )
		{
			this._configurator = afc;
		}
		else
		{
			this._configurator = null;
		}

		this.reset()

		/** @type {Boat?} */
		this.boat = null;
	}

	reset()
	{
		this.recipe_categories =
			[ new Recipe_Category("Standard"          )
			, new Recipe_Category("Premium"           )
			, new Recipe_Category("No_Biocide"        )
			, new Recipe_Category("No_Biocide_Premium")
		]
		for( var i0C = 0 ;  i0C < this.recipe_categories.length ;  i0C++ )
		{
			this.recipe_categories[i0C].index0 = i0C
			this.recipe_categories[i0C].reset();
		}
		this._product_values.length = 0
		if( (this._category_selected_index0 < 0)
			|| (this._category_selected_index0 >= this.recipe_categories.length) )
		{
			this._category_selected_index0 = -1
		}
	}

	get product_kind_id() { return "Antifouling"; }
	get product_category_ids()
	{
		return ["Standard" , "Premium" , "No_Biocide" , "No_Biocide_Premium"];
	}

	recipe_categories =
		[ new Recipe_Category("Standard"          )
		, new Recipe_Category("Premium"           )
		, new Recipe_Category("No_Biocide"        )
		, new Recipe_Category("No_Biocide_Premium")
	]

	/** @private  @type {Recipe_Product[]} */
	_product_values = []

	get product_values() { return this._product_values; }

	_category_selected_index0 = -1

	get category_selected_index0()
	{
		return this._category_selected_index0;
	}

	/** @returns { Recipe_Category | null } */
	get selected_category()
	{
		return this.get_selected_category();
	}

	/** @returns { Recipe_Category | null } */
	get_selected_category()
	{
		const i0 = this._category_selected_index0

		if( (i0 >= 0) 
			&& (i0 < this.recipe_categories.length) )
		{
			return this.recipe_categories[i0];
		}

		return null;
	}

	/** 
	 * @param {Recipe_Category | null | number} category_or_index1  
	 * @returns {number}
	 * */
	select_category( category_or_index1 )
	{
		var index0 = -1
		
		if( (null === category_or_index1)
			|| (0 === category_or_index1) )
		{
			this._category_selected_index0 = -1
			console.debug("Recipe: no category selected")
			return 0;
		}

		if( category_or_index1 instanceof Recipe_Category )
		{
			index0 = this.recipe_categories.indexOf(category_or_index1)
		}
		else
		if( "number" === typeof(category_or_index1) 
			&& Number.isInteger(category_or_index1) )
		{
			index0 = category_or_index1 - 1
		}
		// else
		// if( "string" === typeof(category_or_index1) )
		// {
		// 	index0 = category_or_index1 - 1
		// }

		if( index0 >= 0 
			&& (index0 < this.recipe_categories.length) )
		{
			this._category_selected_index0 = index0;
			const category = this.recipe_categories[index0]
			console.debug( "Recipe: selected category: " 
				+ category.product_category_id 
				+ " (" + category.index1 + ")" )
			return index0 + 1;
		}

		return -1;
	}

	/** @returns {Product?} */
	get product_selected()
	{
		const i0 = this._category_selected_index0
		if( (i0 >= 0) && (i0 < this.recipe_categories.length) )
		{
			const category = this.recipe_categories[i0]
			const values = category.get_main_recipe_product()
			if( values instanceof Recipe_Product )
			{
				return values.get_product();
			}
			else
			{
				return null;
			}
		}
		else
		{
			this._category_selected_index0 = -1
			return null;
		}
	}

	/**
	 * @param {number} index1
	 * @param {Product_Kind | string} kind_or_id
	 * @returns {Recipe_Product}
	 */
	get_selected_product_by_kind( kind_or_id , index1 = 1 )
	{
		const kind = Product_Kind.get( kind_or_id )
		const category = this.selected_category

		if( typeof(index1) != "number" ) {index1 = 1}
		if( Number.isNaN(index1) ) {index1 = 1}
		if( index1 < 1 ) {index1 = 1}

		if( (kind instanceof Product_Kind)
			&& (category instanceof Recipe_Category) )
		{
			const rproducts = category.get_recipe_products_by_kind_id( kind.id )

			if( rproducts.length > 0 )
			{
				if( index1 > rproducts.length )
				{
					return null;
				}

				return rproducts[index1 - 1];
			}
		}

		return null;
	}


	set_boat_recipe_products()
	{
		this.p_antifouling = null
		this.p_primer      = null
		this.p_tiecoat     = null

		this.p_antifouling = this.get_selected_product_by_kind( "Antifouling" )
		this.p_primer      = this.get_selected_product_by_kind( "Primer" )
		this.p_tiecoat     = this.get_selected_product_by_kind( "Tie_Coat" )
	}
}


class Recipe_Category
{
	/** @private */
	_product_category_id = "";
	get product_category_id() {	return this._product_category_id; }

	/** @private  @type {Product_Category?} */
	_product_category = null
	get product_category()
	{
		if( this._product_category instanceof Product_Category )
		{
			return this._product_category;
		}

		this._product_category = Product_Category.get( this.product_category_id )

		return this._product_category;
	}

	/** @private  @type { number } */
	_index0 = -9;
	get index0() 		{ return this._index0;	}
	get index1() 		{ return this._index0 + 1;	}
	set index0( i0 )
	{
		if( (typeof(i0) === "number")
			&& Number.isInteger( i0 )
			&& (i0 >= 0) )
		{
			this._index0 = i0;
		}
	}
	set index1( i1 )
	{
		if( typeof(i1) === "number" )
		{
			this.index0 = i1 - 1;
		}
	}

	/** @returns {number} */
	get amount_multiplier()
	{
		if( this._amount_multiplier < 0 )
		{
			return 0;
		}

		if( this._amount_multiplier == 0 )
		{
			return 1;
		}

		return this._amount_multiplier
	}

	set_amount_multiplier_raw( amount )
	{
		this._amount_multiplier = amount
	}

	/** @returns {boolean} */
	is_amount_multiplier_set()
	{
		return (this._amount_multiplier > 0)
	}

	// /** @type {Colour[]} */
	// _Colours_Available = []
	// /** @private  @type {Colour?} */
	// _Colour = null
	// get Colour() { return this._Colour; }

	/** @private  @type {Recipe_Product} */
	_main_recipe_product = null
	/** @private  @type {Recipe_Product[]} */
	_recipe_products = []
	/**   @type {Object.<string,Recipe_Product[]>} */
	_recipe_product_by_id = {}
	/** @private  @type {Object.<string,Recipe_Product[]>} */
	_recipe_products_by_kind_id = {}

	/** @type {string[]} */
	_instruction_ids = []

	/** @type {string[]} */
	_step_ids = []
	/** @type {Step[]} */
	_steps = []

	/** @type {Colour[]} */
	_available_Colours = []

	constructor( category_or_id )
	{
		if( typeof(category_or_id)==="string" )
		{
			category_or_id = category_or_id.trim()
			this._product_category_id = category_or_id
			category_or_id = Product_Category.get( category_or_id )
		}
		if( category_or_id instanceof Product_Category )
		{
			this._product_category = category_or_id
			this._product_category_id = this._product_category.id
		}
		this.reset();
	}

	/** @param {Colour?} */
	reset( colour = null )
	{
		this._main_recipe_product = null;

		this._available_Colours.length = 0

		this._highest_value = 0

		this._amount_multiplier = -1
		this._amount_ml_total = -1
		this._recipe_products = []
		this._recipe_product_by_id = {}
		this._recipe_products_by_kind_id = {}

		this._instruction_ids = []
		this._instructions = []

		this._step_ids = []
		this._steps = []
	}


	/**
	 * @returns {number}
	 * @param {Recipe_Product!} p  */
	set_main_recipe_product( p )
	{
		if( p instanceof Recipe_Product )
		{
			this.reset()
			this._main_recipe_product = p
			this._recipe_products = [ p ]
			const kind_id = p.product.kind_id
			this._recipe_product_by_id = {}
			this._recipe_product_by_id[p.product_id] = p
			this._recipe_products_by_kind_id = {}
			this._recipe_products_by_kind_id[kind_id] = [p]
			return 1;
		}
		return -1;
	}


	is_included()
	{
		if( this._main_recipe_product instanceof Recipe_Product )
		{
			const rp = this.get_main_recipe_product()
			if( rp instanceof Recipe_Product )
			{
				if( rp.is_not_excluded )
				{
					return true;
				}
			}
		}
		return false;
	}


	is_included_and_has_value( min_value = 0 )
	{
		if( (this.get_highest_value() >= min_value ) 
			&& this.is_included() )
		{
			return true;
		}

		return false;
	}


	get_highest_value()
	{
		return this._highest_value;
	}


	/** @returns {Recipe_Product?} */
	get_main_recipe_product()
	{
		if( this._main_recipe_product instanceof Recipe_Product )
		{
			return this._main_recipe_product;
		}
		return null;
	}

	/** @returns {Recipe_Product[]} */
	get_recipe_products_by_kind_id( kind_id )
	{
		if( kind_id in this._recipe_products_by_kind_id )
		{
			return this._recipe_products_by_kind_id[kind_id];
		}
		return [];
	}

	/**
	 * @returns {number}
	 * @param {Recipe_Product!} p  */
	add_recipe_product( p )
	{
		if( (p instanceof Recipe_Product)
			&& (this._main_recipe_product instanceof Recipe_Product) )
		{
			if( this._recipe_products.indexOf(p) < 0 )
			{
				this._recipe_products.push(p)
				this._recipe_product_by_id[p.product_id] = p

				const kind_id = p.get_product().kind_id
				if( (kind_id in this._recipe_products_by_kind_id) == false )
				{
					this._recipe_products_by_kind_id[kind_id] = [p]
				}
				else
				{
					this._recipe_products_by_kind_id[kind_id].push(p)
				}

				return this._recipe_products.length;
			}
		}
		return 0;
	}
}

class Recipe_Product
{
	constructor( product_or_id )
	{
		if( typeof(product_or_id) === "string" )
		{
			product_or_id = product_or_id.trim()
			this._product_id = product_or_id
			product_or_id = Product.get( product_or_id )
		}
		if( product_or_id instanceof Product )
		{
			this._product_reference = product_or_id
			this._product_id = product_or_id.id
		}
	}

	/** @private  @type { string } */
	_product_id = ""
	get product_id() { return this._product_id; }

	/** @private  @type { Product? } */
	_product_reference = null
	/** @returns { Product? } */
	get product()
	{
		if( (this._product_reference != null) && (this._product_reference instanceof Product) )
		{
			return this._product_reference;
		}
		else
		{
			this._product_reference = Product.get( this._product_id )
			return this._product_reference;
		}
	}

	get_product()
	{
		if( (this._product_reference != null) && (this._product_reference instanceof Product) )
		{
			return this._product_reference;
		}
		else
		{
			this._product_reference = Product.get( this._product_id )
			return this._product_reference;
		}
	}

	get_coverage_sqm_per_l( fallback = 10.0 )
	{
		const product = this.get_product()
		if( product instanceof Product )
		{
			return product.get_coverage_sqm_per_l( fallback )
		}

		return fallback;
	}

	/** @type { number } */
	static get DEFAULT_VALUE() { return 100; }

	/** @private */
	_calculation = new Recipe_Product_Calculation_Data( this )
	get calculation() { return this._calculation; }

	get is_excluded() { return (this._calculation.exclusions.length >= 1); }
	get is_not_excluded() { return (this._calculation.exclusions.length === 0); }

	get value() { return this._calculation.value; }

	reset_calculation()
	{
		this._calculation.reset()
	}

	/** @private  @type { number } */
	_index0 = -999999999;
	get index0() 		{ return this._index0;	}
	get index1() 		{ return this._index0 + 1;	}
	set index0( value )
	{
		if( (typeof(value) === "number")
			&& (value >= 0) )
		{
			this._index0 = value;
		}
	}
	set index1( value )
	{
		if( (typeof(value) === "number")
			&& (value >= 1) )
		{
			this._index0 = value - 1;
		}
	}

	/** @private  @type { Colour? } */
	_selected_Colour = null;
	get selected_Colour()	{ return this._selected_Colour;	}
	get has_Colour()
	{
		return (Colour.is_Colour(this._selected_Colour))
				&& (this._product_reference._Colours.indexOf(this._selected_Colour) >= 0);
	}

	/** @private */
	_needed_multiplier = 0;
	get needed_multiplier()	{ return this._needed_multiplier; }
	/** @private */
	_needed_amount = 0;
	get needed_amount()	{ return this._needed_amount; }
	/** @private */
	_needed_amount_total = 0 ;
	get needed_amount_total() {	return this._needed_amount_total; }

	/** @type { number[] } */
	_variant_counts = []
	/** @type { Product_Variant[] } */
	_variants = []

	// /** @private  @type { number[] } */
	// _variant_index0s = []

	are_NO_variants_picked()
	{
		if( this._variant_counts.length > 0
			&& this._variants.length === this._variant_counts.length )
		{
			return false;
		}

		this._reset_variants()

		return true;
	}

	has_variants_picked()
	{
		return false === this.are_NO_variants_picked();
	}

	/** @private */
	_reset_variants()
	{
		this._variant_counts = []
		this._variants = []
		// this._variant_index0s = []
	}

	/** @private */
	_calculated_amount_total = 0;
	get calculated_amount_total()
	{
		return this._calculated_amount_total;
	}

	set_to_Colour( colour )
	{
		if( colour == this._selected_Colour )
		{
			return 0;
		}

		if( Colour.is_Colour(colour) )
		{
			if( this._product_reference.has_Colour(colour) == false )
			{
				colour = null
			}

			if( colour == this._selected_Colour )
			{
				return 0;
			}

			this._selected_Colour = colour

			this._reset_variants()

			this._calculated_amount_total = 0;

			return 1;
		}

		return -2;
	}


	set_to_amount( amount , amount_multiplyer = 1.0  )
	{
		if( (amount === this.needed_amount) && (amount_multiplyer == this.needed_multiplier) )
		{
			return this.needed_amount_total
		}

		if( typeof(amount)!="number" ) { return -4; }
		if( typeof(amount_multiplyer) != "number") { return -8; }
		if( amount < 0 ) { return -32; }
		if( amount_multiplyer < 0 ) { return -64; }

		this._reset_variants();
		this._calculated_amount_total = 0;

		this._needed_amount = amount
		this._needed_multiplier  = amount_multiplyer
		this._needed_amount_total = amount * amount_multiplyer

		return this._needed_amount_total;
	}

	set_to_amount_multiplier( amount_multiplyer )
	{
		this.set_to_amount( this._needed_amount , amount_multiplyer )
	}

	pick_variants( again = true )
	{
		const product = this.get_product()

		if( product instanceof Product )
		{
			/** @type {number[]} */
			var amounts = [];
			var variants_by_amount = null;

			const colour = this._selected_Colour
			if( Colour.is_Colour(colour) )
			{
				amounts = product._amounts_by_Colour.get(colour)
				variants_by_amount = product._variants_by_Colour_by_amount_sorted_by_relative_value.get(colour)
			}
			else
			{
				amounts = product._amounts_without_Colour
				variants_by_amount = product._variants_without_Colour_by_amount
			}

			if( Array.isArray(amounts) === false
				|| (variants_by_amount instanceof Map) === false
				|| this._needed_amount_total <= 0 )
			{
				return;
			}

			const variant_options = []
			for( const amount of amounts )
			{
				const variants = variants_by_amount.get(amount)
				if( Array.isArray(variants)
					&& variants.length > 0
					&& variants[0] instanceof Product_Variant
					&& variants[0].has_amount(amount) )
				{
					variant_options.push( variants[0] )
				}
			}

			if( variant_options.length <= 0 )
			{
				return;
			}

			const unit_ml = get_common_unit_ml( variant_options )
			const needed_units = Math.ceil( this._needed_amount_total / unit_ml )
			const max_amount_ml = Math.max( ...variant_options.map( v => v.amount ) )
			const min_amount_ml = Math.min( ...variant_options.map( v => v.amount ) )
			const max_units = needed_units + Math.ceil( max_amount_ml / unit_ml )
			const states = new Array( max_units + 1 )

			states[0] =
			{
				volume_ml: 0,
				price: 0,
				item_count: 0,
				counts: new Array( variant_options.length ).fill(0)
			}

			for( var i0state = 0 ;  i0state <= max_units ; ++i0state )
			{
				const state = states[i0state]
				if( state == null ) { continue; }

				for( var i0option = 0 ;  i0option < variant_options.length ; ++i0option )
				{
					const variant = variant_options[i0option]
					const next_units = i0state + Math.round( variant.amount / unit_ml )
					if( next_units > max_units ) { continue; }

					const next_state =
					{
						volume_ml: state.volume_ml + variant.amount,
						price: state.price + get_variant_price( variant ),
						item_count: state.item_count + 1,
						counts: state.counts.slice()
					}
					next_state.counts[i0option] += 1

					if( is_better_state( next_state , states[next_units] ) )
					{
						states[next_units] = next_state
					}
				}
			}

			var best_overage_ml = null
			for( var i0best = needed_units ;  i0best <= max_units ; ++i0best )
			{
				const state = states[i0best]
				if( state != null
					&& state.volume_ml >= this._needed_amount_total )
				{
					const overage_ml = state.volume_ml - this._needed_amount_total
					if( best_overage_ml == null || overage_ml < best_overage_ml )
					{
						best_overage_ml = overage_ml
					}
				}
			}

			var best_state = null
			for( var i0candidate = needed_units ;  i0candidate <= max_units ; ++i0candidate )
			{
				const state = states[i0candidate]
				if( state != null
					&& state.volume_ml >= this._needed_amount_total
					&& best_overage_ml != null
					&& ( state.volume_ml - this._needed_amount_total ) <= ( best_overage_ml + min_amount_ml )
					&& is_better_order_state( state , best_state , this._needed_amount_total ) )
				{
					best_state = state
				}
			}

			if( best_state != null )
			{
				this._calculated_amount_total = best_state.volume_ml
				for( var i0picked = 0 ;  i0picked < best_state.counts.length ; ++i0picked )
				{
					const count = best_state.counts[i0picked]
					if( count > 0 )
					{
						this._variant_counts.push(count)
						this._variants.push(variant_options[i0picked])
					}
				}
			}
		}

		function get_variant_price( variant )
		{
			if( variant instanceof Product_Variant
				&& typeof(variant.price) === "number"
				&& Number.isFinite(variant.price)
				&& variant.price >= 0 )
			{
				return variant.price;
			}
			return 0;
		}

		function get_common_unit_ml( variants )
		{
			var result = 0
			for( const variant of variants )
			{
				const amount = Math.max( 1 , Math.round( variant.amount ) )
				result = ( result <= 0 ) ? amount : greatest_common_divisor( result , amount )
			}
			return Math.max( 1 , result )
		}

		function greatest_common_divisor( a , b )
		{
			a = Math.abs( Math.round(a) )
			b = Math.abs( Math.round(b) )
			while( b > 0 )
			{
				const next = a % b
				a = b
				b = next
			}
			return Math.max( 1 , a )
		}

		function is_better_state( candidate , current )
		{
			if( current == null ) { return true; }
			if( candidate.price !== current.price ) { return candidate.price < current.price; }
			if( candidate.item_count !== current.item_count ) { return candidate.item_count < current.item_count; }
			return candidate.volume_ml < current.volume_ml;
		}

		function is_better_order_state( candidate , current , needed_amount_total )
		{
			if( current == null ) { return true; }

			const candidate_overage = candidate.volume_ml - needed_amount_total
			const current_overage = current.volume_ml - needed_amount_total

			if( candidate.price !== current.price ) { return candidate.price < current.price; }
			if( candidate_overage !== current_overage ) { return candidate_overage < current_overage; }
			return candidate.item_count < current.item_count;
		}
	}
}


class Recipe_Product_Calculation_Data
{
	/** @private  @type { number } */
	static get DEFAULT_VALUE()
	{
		return Recipe_Product.DEFAULT_VALUE;
	}

	/** @param {!Recipe_Product} recipe_product */
	constructor( recipe_product )
	{
		this._recipe_product = recipe_product
		if( !(recipe_product instanceof Recipe_Product))
		{
			this._recipe_product = null
		}

		this.reset();
	}

	reset()
	{
		/** @type { Rule[] } */
		this.applied_rules = []

		/** @type { Rule[] } */
		this.exclusions = []

		this.value = Recipe_Product_Calculation_Data.DEFAULT_VALUE;

		this.amount = 0

		/** @type {string[]} */
		this.instruction_ids = []
		/** @type {Instruction[]} */
		this.instruction_references = []
		/** @type {number[]} */
		this.instruction_values = []
		/** @type {string[]} */
		this.instruction_step_ids = []
		/** @type {Step[]} */
		this.instruction_steps = []
	}

	get_amount()
	{
		if( this.amount < 0 )
		{
			return 0;
		}

		if( this.amount == 0 )
		{
			return 1;
		}

		return this.amount;
	}

	set_amount( amount )
	{
		this.amount = amount;
	}

	set_amount_raw( amount )
	{
		this.amount = amount;
	}

	get recipe_product() { return this._recipe_product; }
}


class Recipe_Calculator
{
	/**
	 * @param {Configurator_AF!} afc
	 * @param {Recipe!} recipe
	 * */
	constructor( afc , recipe )
	{
		/** @private  @type {Configurator_AF!} */
		this._configurator = afc

		/** @private  @type {Recipe!} */
		this._recipe = recipe

		/** @private  */
		this._Colour = Colour.Default_Colour

		/** @private  @type {Rule[]} */
		this._applied_rules = []
		/** @private  @type {Rule[]} */
		this._further_rules_to_apply = []

		/** @private  @type {Recipe_Product[]} */
		this._product_values = []
		/** @private  @type {Object.<string,Recipe_Product>} */
		this._product_values_by_id = {}
		/** @private  @type {Object.<string,Object.<string,Recipe_Product>>} */
		this._product_values_by_category_id = {}

		/** @private  */
		this._calculated = -1

		/**
		* @callback recipe_calculator_callback
		* @param {Recipe_Calculator} recipe_calculator
		*/

		/** @private  @type {recipe_calculator_callback?} */
		this._callback = null
	}

	is_calculated()
	{
		return (this._calculated > 0);
	}

	get_calculated_state()
	{
		return this._calculated;
	}

	/** @param {Colour?} colour  */
	calculate( colour = null )
	{
		this._calculated = 0;

		const recipe = this._recipe

		const unanswered_question = this._configurator.get_first_unanswered_question();

		// if( Question.are_all_questions_answered === true )
		// if( this._configurator.are_all_questions_answered() )
		if( null === unanswered_question )
		{
			if( Colour.is_Colour(colour) == false )
			{
				recipe.reset()

				this._prepare_product_values()

				this._apply_rules()

				this.calculate_boat( recipe.boat )

				this._pick_products_for_all_categories()

				this._apply_instructions_for_picked_products()

				this._fill_steps()

				this._pick_colours()

				this._select_category()
			}

			this._apply_amounts_for_picked_products()

			recipe.set_boat_recipe_products();

			this._calculated = 1;
		}
		else
		{
			console.debug(
				"Not all questions have been answered: " , 
				unanswered_question.order )
		}
	}


	/** @private */
	_prepare_product_values()
	{
		const recipe = this._recipe
		const collected_products = this._product_values
		collected_products.length = 0;
		const collected_products_by_product_id = this._product_values_by_id
		const collected_products_by_category_id = this._product_values_by_category_id

		for( var iCID=0 ;  iCID < recipe.recipe_categories.length ;  iCID++ )
		{
			const category_id = recipe.recipe_categories[iCID].product_category_id

			const category = Product_Category.get( category_id )
			if( category instanceof Product_Category )
			{
				collected_products_by_category_id[category_id] = {}

				for( var iPID=0 ;  iPID < category.product_ids.length ;  iPID++ )
				{
					const product_id = category.product_ids[iPID]

					const product = Product.get(product_id)

					if( product instanceof Product )
					{
						const new_data = new Recipe_Product( product )
						collected_products.push( new_data )
						collected_products_by_category_id[category_id][product.id] =
						collected_products_by_product_id[product.id] = new_data
					}
				}
			}
		}
	}


	/** @private */
	_apply_rules( )
	{
		this._applied_rules.length = 0
		const further_rules_to_apply = this._further_rules_to_apply
		further_rules_to_apply.length = 0;

		for( var iQ = 0;  iQ < Question.all_in_order.length;  iQ++ )
		{
			/** @type {Question} */
			const question = Question.all_in_order[ iQ ];

			const answers = question.get_given_answers();
			for( var iA = 0;  iA < answers.length;  iA++ )
			{
				const answer = answers[iA]

				const rules = Rule.get_by_answer(answer)
				for( var iR = 0;  iR < rules.length;  iR++ )
				{
					const rule = rules[iR];

					if( rule.selection_value == null )
					{
						this._apply_rule( rule )
					}
					else
					{
						if( answer.has_selection === true )
						{
							const r_value = rule.selection_value
							const a_value = answer.selection.get_value()
							if( r_value == a_value )
							{
								this._apply_rule( rule )
							}
						}
					}
				}
			}
		}

		for( var iR = 0;  iR < Rule.general_rules.length;  iR++ )
		{
			const rule = Rule.general_rules[iR];

			this._apply_rule( rule )
		}

		var iR = 0;
		while( iR < further_rules_to_apply.length )
		{
			const rule = further_rules_to_apply[iR++];

			this._apply_rule( rule )
		}

		develope.message( "Applied Rules:" , this._applied_rules );
	}


	/**
	 * @private
	 * @param {Rule} rule 
	 * */
	_apply_rule( rule )
	{
		const applied_rules = this._applied_rules

		if( applied_rules.indexOf( rule ) < 0 )
		{
			const product_ids = rule.for_product_ids

			for( var i0PID = 0 ;  i0PID < product_ids.length ;  i0PID++ )
			{
				const product_id = product_ids[i0PID];

				if( product_id in this._product_values_by_id )
				{
					const values = this._product_values_by_id[product_id]
					if( values instanceof Recipe_Product
						&& values.calculation instanceof Recipe_Product_Calculation_Data )
					{
						this._apply_rule_for_product( values.calculation , rule )
					}
				}
			}

			applied_rules.push(rule)
		}
		else
		{
			develope.message( "Rule already applied" , rule )
		}
	}

	/**
	 * @private
	 * @param {Recipe_Product_Calculation_Data} values
	 * @param {Rule} rule
	 * */
	_apply_rule_for_product( values , rule )
	{
		if( false == (rule instanceof Rule) )
		{
			return -2;
		}

		const further_rules_to_apply = this._further_rules_to_apply

		switch( rule.action )
		{
			case Rule.Actions.exclude:
			{
				values.exclusions.push( rule )
			} break;

			case Rule.Actions.value:
			{
				values.value = rule.value
			} break;

			case Rule.Actions.amount_set:
			{
				values.amount = rule.value
			} break;

			case Rule.Actions.amount_increase:
			{
				values.amount += rule.value
			} break;

			case Rule.Actions.percent:
			{
				values.value *= rule.value
				values.value /= 100
			} break;

			case Rule.Actions.instruction:
			{
				for( const instruction_id of rule.instruction_ids )
				{
					values.instruction_ids.push(instruction_id)
					values.instruction_step_ids.push("")
					values.instruction_values.push(rule.value)
				}
			} break;

			case Rule.Actions.instruction_for_step:
			{
				for( const instruction_id of rule.instruction_ids )
				{
					values.instruction_ids.push(instruction_id)
					values.instruction_step_ids.push(rule.step_id)
					values.instruction_values.push(rule.value)
				}
			} break;

			case Rule.Actions.rules:
			{
				for( var i1R = 1;  i1R <= rule.rule_ids.length ;  i1R++ )
				{
					further_rules_to_apply.push( rule.get_rule(i1R) )
				}
			} break;

			case Rule.Actions.Default:
			default:
			{
				develope.error( "unknown Rule action")
			} break;
		}

		return 1;
	}

	/**
	 * @param {Boat} boat
	 * */
	calculate_boat( boat )
	{
		boat.calculate_area()

		console.debug(
			"Boat:"
			+ " " + "effective=" + boat.effective_area_in_square_m    + "m²"
			+ " " + "factor="    + boat.factor
			+ " " + "area="      + boat._calculated_area_in_square_cm + "cm²"
		)
	}


	/** @private */
	_pick_products_for_all_categories()
	{
		const recipe = this._recipe
		const collected = this._product_values_by_category_id
		const recipe_products_by_id = this._product_values_by_id

		for( var i0C = 0 ;  i0C < recipe.recipe_categories.length ;  i0C++ )
		{
			const category = recipe.recipe_categories[i0C]
			const category_id = category.product_category_id

			if( category_id in collected )
			{
				var highest_value = 0;

				for( const p_id in collected[category_id] )
				{
					const recipe_product = recipe_products_by_id[p_id]

					if( (recipe_product.value > highest_value) 
						&& (recipe_product.is_not_excluded) )
					{
						highest_value = recipe_product.value
						category.set_main_recipe_product( recipe_product )
					}
				}

				const main_recipe_product = category.get_main_recipe_product()
				if( main_recipe_product instanceof Recipe_Product )
				{
					category._highest_value = highest_value

					category.set_amount_multiplier_raw( main_recipe_product.calculation.amount )

					const values = main_recipe_product.calculation

					for( const instruction_id of values.instruction_ids )
					{
						category._instruction_ids.push( instruction_id )
					}

					if( recipe.product_selected == null )
					{
						recipe.select_category( category )
					}
				}
			}
		}
	}


	/** @private */
	_select_category()
	{
		const MODE_SELECT_FIRST = 1
		const MODE_SELECT_LAST  = 2
		// const MODE_SELECT_HIGHEST_VALUE = 3

		const mode = MODE_SELECT_FIRST

		const recipe = this._recipe

		if( recipe.selected_category instanceof Recipe_Category )
		{
			const selected = recipe.selected_category
			if( selected.is_included_and_has_value( 1 ) )
			{
				return;
			}
		}

		const categories = recipe.recipe_categories

		for( var i0 = 0 ;  i0 < categories.length ;  ++i0 )
		{
			const category = categories[i0]
			
			if( mode === MODE_SELECT_FIRST )
			{
				if( recipe.product_selected == null )
				{
					recipe.select_category( category )
					return;
				}
			}
			else
			if( mode === MODE_SELECT_LAST )
			{
				if( category.is_included_and_has_value( 1 ) )
				{
					recipe.select_category( category )
				}
			}
		}
	}


	/** @private */
	_fill_steps()
	{
		const recipe = this._recipe;

		for( const category of recipe.recipe_categories )
		{
			category._steps.length = 0
			category._step_ids.length = 0

			const product = category.get_main_recipe_product()

			if( product instanceof Recipe_Product )
			{
				/** @type {Object.<string,Step>} */
				const steps = {}
				/** @type {Step[]} */
				const steps_in_order = []

				steps.remove = Step.get("remove").empty_copy()
				steps.wash   = Step.get("wash"  ).empty_copy()
				steps.grind  = Step.get("grind" ).empty_copy()
				steps.prime  = Step.get("prime" ).empty_copy()
				steps.apply  = Step.get("apply" ).empty_copy()

				steps_in_order.push(steps.remove)
				steps_in_order.push(steps.wash  )
				steps_in_order.push(steps.grind )
				steps_in_order.push(steps.prime )
				steps_in_order.push(steps.apply )

				for( const instruction_id of category._instruction_ids )
				{
					const instruction = Instruction.get( instruction_id )
					const product = category.get_main_recipe_product()

					if( (instruction instanceof Instruction)
						&& (product instanceof Recipe_Product) )
					{
						if( instruction.step_id in steps )
						{
							steps[instruction.step_id].instruction_ids.push( instruction.id )
							steps[instruction.step_id].activate()
						}
					}
				}

				for( const step of steps_in_order )
				{
					if( true === step.active )
					{
						category._steps.push(step)
					}
				}
			}
		}
	}


	/** @private */
	_pick_colours()
	{
		for( const category of this._recipe.recipe_categories )
		{
			category._available_Colours.length = 0

			const Colours = []

			if( category.get_main_recipe_product() instanceof Recipe_Product )
			{
				for( const recipe_product of category._recipe_products )
				{
					if( recipe_product instanceof Recipe_Product )
					{
						const product = recipe_product.product
						if( product instanceof Product )
						{
							if( product.has_Colour() )
							{
								for( const c of product._Colours )
								{
									if( Colour.is_Colour(c) )
									{
										tools_array_push_if_not_included( Colours , c )
									}
								}

								const c = recipe_product.selected_Colour
								if( product.has_Colour(c) )
								{
									recipe_product.set_to_Colour(c)
								}
								else
								{
									recipe_product.set_to_Colour( product.get_Colour(1) )
								}
							}
							else
							{
								recipe_product.set_to_Colour( null )
							}
						}
					}
				}

				category._available_Colours = Colours
			}
		}
	}


	/** @private */
	_apply_instructions_for_picked_products()
	{
		const recipe = this._recipe

		for( const category of recipe.recipe_categories )
		{
			for( const instruction_id of category._instruction_ids )
			{
				const instruction = Instruction.get(instruction_id)
				if( instruction instanceof Instruction )
				{
					if( instruction.amount > 0 )
					{
						if( instruction.instruction_product_id.length < 1 )
						{
							category._amount_multiplier += instruction.amount
						}
						else//if( instruction.instruction_product_id.length > 0 )
						{
							const product_ids = tools_to_string_array(instruction.instruction_product_id)

							for( const product_id of product_ids )
							{
								var recipe_product = null

								if( product_id in category._recipe_product_by_id )
								{
									var recipe_product = category._recipe_product_by_id[product_id]
								}
								else
								if( product_id in this._product_values_by_id )
								{
									var recipe_product = this._product_values_by_id[product_id]
								}
								else
								{
									recipe_product = new Recipe_Product( product_id )
								}

								if( recipe_product instanceof Recipe_Product )
								{
									if( instruction.amount > 0 )
									{
										recipe_product.set_to_amount_multiplier( instruction.amount )
									}

									category.add_recipe_product( recipe_product )
								}
							}
						}
					}
				}
			}
		}
	}


	/** @private */
	_apply_amounts_for_picked_products()
	{
		const recipe = this._recipe

		const area_in_square_m = recipe.boat.effective_area_in_square_m
		const fallback_coverage_sqm_per_l = 10.0

		for( const category of recipe.recipe_categories )
		{
			if( category.get_main_recipe_product() instanceof Recipe_Product )
			{
				const kind_ids = ["Antifouling" , "Primer" , "Tie_Coat"]
				for( const kind_id of kind_ids )
				{
					const recipe_products = category.get_recipe_products_by_kind_id(kind_id)
					for( const recipe_product of recipe_products )
					{
						if( recipe_product instanceof Recipe_Product )
						{
							if( recipe_product.are_NO_variants_picked() )
							{
								const coverage_sqm_per_l = recipe_product.get_coverage_sqm_per_l( fallback_coverage_sqm_per_l )
								const amount_ml = 1000.0
									* area_in_square_m
									/ coverage_sqm_per_l
								const amount_multiplier =
									( recipe_product.needed_multiplier > 0 )
										? recipe_product.needed_multiplier
										: category.amount_multiplier

								if( kind_id === "Antifouling" )
								{
									category._amount_ml_total = amount_ml
								}

								recipe_product.set_to_amount( amount_ml , amount_multiplier )
								recipe_product.pick_variants()
								console.debug( ""
									+ recipe_product.product.id + ":"
									+ " " + recipe_product._variants.length + " variant(s) picked "
									+ "\n" 
									+ " category=" + category.product_category_id + ":"
									+ " kind=" + kind_id + ":"
									+ " product=" + recipe_product.product.label + ":"
								)
							}
						}
					}
				}
			}
		}
	}

	/**
	 * @param {function?} callback
	 * @returns {number}
	 * */
	set_callback( callback )
	{
		if( ( "function" === typeof(callback) )
			&& (callback.length >= 1 ) )
		{
			this._callback = callback
			return 1;
		}
		else
		{
			if( null == callback )
			{
				this._callback = null
				return 0;
			}
		}

		return -2;
	}

	/** @returns {number} */
	call_callback( )
	{
		if( this._callback == null )
		{
			return -1;
		}
		else
		{
			const result = this._callback(this)
			if( typeof(result) != "number" )
			{
				return 0;
			}
			return result;
		}
	}
}


class Shopify_Tools
{
	static get IN_VISUAL_PREVIEW() { return  5; }
	static get IN_EDITOR()         { return 17; }
	static get IN_SHOP()           { return 33; }

	static get Shopify_Object() { return window.Shopify }

	static _on_editor_change = []
	static _editor_shopify_section_load_handler( x )
	{
		console.debug( x )
	}

	/** @returns {number} */
	static get Shopify_State()
	{
		var result = 0;
		const s = this.Shopify_Object
		if( s )
		{
			result = this.IN_SHOP
			if( s.visualPreviewMode ) { result = this.IN_VISUAL_PREVIEW; }
			if( s.designMode )        { result = this.IN_EDITOR;         }
		}
		return result;
	}

	static put_into_cart( variant_ids = [], quantitys = [] , properties = {} )
	{
		const ordered = {
			fetch: null ,
			json: null ,
			result: ""
		}

		if( this.Shopify_State >= this.IN_EDITOR )
		{
			const route_root = Shopify.routes.root
			const cart_url = route_root + 'cart/add.js'
			// const query = new Query( Shopify.routes.root )

			const title = "ABC-Test"

			const order_data = {
				'items': []
			}

			const length = variant_ids.length;
			for( var i0 = 0  ;  i0 < length  ;  ++i0 )
			{
				const variant_id = variant_ids[i0]
				const quantity = quantitys[i0]

				order_data.items.push(
					{
						id: variant_id,
						quantity: quantity,
						properties: properties,
						title: title
					}
				)
			}

			ordered.fetch
			= fetch(
				cart_url ,
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json'	},
					body: JSON.stringify( order_data )
				}
			)
			.then( 	(response)=>
				{
					ordered.result = response;
					const json = response.json();
					json.then( (data) => {
						ordered.json = data;
					});
					develope.message('cart: ', ordered );

					return ordered;
				}
			)
			.catch(	(error)=>
				{
					develope.error('cart-error:', error , ordered );
					console.error('Error:', error );
				}
			);
		}

		return ordered;
	}

	/** @returns { string | null } */
	static get_theme_schema_name()
	{
		if( Shopify_Tools.Shopify_State > 0 )
		{
			const s = Shopify_Tools.Shopify_Object

			try
			{
				const name = s.theme.schema_name
				if( typeof( name ) == "string"
					&& name.length > 0 ) 
				{
					return name.trim().toLowerCase();
				}
			}
			catch( error ){}
		}

		return null;
	}

	static get Themes()
	{
		const concept = { schema_name: "concept" }

		return (
			{
				concept
			}
		)
	}

	/** @param {object} theme  */
	static theme_is( theme )
	{
		const shema_name = Shopify_Tools.get_theme_schema_name()

		if( null == shema_name )
		{
			return false;
		}

		if( theme && theme.schema_name )
		{
			if( theme.schema_name === shema_name )
			{
				return true;
			}
		}

		return false;
	}

	static theme_concept_update_cart_event( open_cart = false , delay_ms = 100 )
	{
		if( "concept" == Shopify_Tools.get_theme_schema_name() )
		{
			window.setTimeout(
				() => {
					document.dispatchEvent(
						new CustomEvent(
							'ajaxProduct:added',
							{
								bubbles: true
							}
						)
					);
					document.dispatchEvent(
						new CustomEvent(
							'cart:refresh',
							{
								bubbles: true,
								detail: { open: open_cart }
							}
						)
					);
				},
			delay_ms );
		}
	}


}


class Developement_Helpers
{
	constructor()
	{
		this.data = {
			errors: []
			, garbage: []
			, messages: []
			, todos: []
		}

		/** @private  @type { boolean } */
		this._do_console_debug = false
	}

	/** @returns {boolean} */
	get is_enabled()
	{
		return true;
	}

	/** @returns {boolean} */
	get do_console_debug()
	{
		return this._do_console_debug;
	}

	enable_console_debug( enable = true )
	{
		if( true == enable )
		{
			if( window && window.console
				&& window.console.debug
				&& (typeof(window.console.debug) === "function")
			) {
				const c = window.console
				this._do_console_debug = true
				return true;
			}
			else
			{
				this._do_console_debug = false
				return false;
			}
		}

		if( false == enable )
		{
			this._do_console_debug = false
			return false;
		}

		return this._do_console_debug;
	}

	disable_console_debug()
	{
		this._do_console_debug = false
		return false;
	}

	/** @returns {boolean} */
	get do_console_error()
	{
		return false;
	}

	hello()
	{
		if( this.is_enabled )
		{
			console.debug("dev:", this.data)
		}
	}

	error(...x)
	{
		if( this.is_enabled )
		{
			this.data.errors.push(...arguments)
		}

		if( this.do_console_error)
		{
			console.error( ...arguments )
		}
		else
		{
			if( this.do_console_debug)
			{
				console.debug( ...arguments )
			}
		}
	}

	garbage_bin(...x)
	{
		if( this.is_enabled  )
		{
			this.data.garbage.push(...arguments)
		}
	}

	garbage_copy(...x)
	{
		if( this.is_enabled )
		{
			this.data.messages.push(...arguments)
		}
	}

	message(...x)
	{
		if( this.is_enabled )
		{
			this.data.messages.push(...arguments)
		}

		if( this.do_console_debug)
		{
			console.debug( ...arguments )
		}
	}

	todo(...what)
	{
		if( this.is_enabled )
		{
			this.data.todos.push(...arguments)
		}
	}
}

/** @type {Developement_Helpers} */
const develope
	= (window && window.develope && (window.develope instanceof Developement_Helpers))
		? (window.develope)
		: new Developement_Helpers()
